export const SELECT_LOCATION = "SELECT_LOCATION";
export const SEARCH_LOCATION = "SEARCH_LOCATION";
export const SEARCH_LOCATION_CLEAR = "SEARCH_LOCATION_CLEAR";
export const CLEAR_LOCATIONS = "CLEAR_LOCATIONS";
export const CLEAR_LOCATIONS_RESULTS = "CLEAR_LOCATIONS_RESULTS";
export const SEARCH_LOCATION_SUCCESS = "SEARCH_LOCATION_SUCCESS";
export const SEARCH_LOCATION_ERROR = "SEARCH_LOCATION_ERROR";
export const GET_LOCATION_TYPES = "GET_LOCATION_TYPES";
export const GET_LOCATION_TYPES_SUCCESS = "GET_LOCATION_TYPES_SUCCESS";
export const GET_FACILITY_TYPES = "GET_FACILITYY_TYPES";
export const GET_FACILITY_TYPES_SUCCESS = "GET_FACILITY_TYPES_SUCCESS";

export const SEARCH_PROVIDER = "SEARCH_PROVIDER";
export const SEARCH_PROVIDER_CLEAR = "SEARCH_PROVIDER_CLEAR";
export const SEARCH_PROVIDER_ERROR = "SEARCH_PROVIDER_ERROR";
export const SEARCH_PROVIDER_BY_LOCAION = "SEARCH_PROVIDER_BY_LOCATION";
export const SEARCH_PROVIDER_BY_NAME = "SEARCH_PROVIDER_BY_NAME";
export const PROVIDER_DETAIL = "PROVIDER_DETAIL";
export const SELECT_PROVIDER = "SELECT_PROVIDER";
export const LOAD_PROVIDERS_SUCCESS = "LOAD_PROVIDERS_SUCCESS";
export const SAVE_PROVIDER_SEARCH_MODEL = "SAVE_PROVIDER_SEARCH_MODEL";
export const LOAD_PROVIDER_DETAIL_SUCCESS = "LOAD_PROVIDER_DETAIL_SUCCESS";
export const CLEAR_PROVIDERS = "CLEAR_PROVIDERS";
export const CLEAR_PROVIDER_DETAIL = "CLEAR_PROVIDER_DETAIL";
export const UPDATE_FACETS = "UPDATE_FACETS";
export const UPDATE_USEMYBSWHEALTH_FILTER = "UPDATE_USEMYBSWHEALTH_FILTER";
export const FIND_CARE_FILTERS_OPEN = "FIND_CARE_FILTERS_OPEN";

export const SEARCH_FOR_GENERIC_PROVIDER = "SEARCH_FOR_GENERIC_PROVIDER";
export const SEARCH_FOR_GENERIC_PROVIDER_SUCCESS = "SEARCH_FOR_GENERIC_PROVIDER_SUCCESS";
export const SEARCH_FOR_GENERIC_PROVIDER_FAILURE = "SEARCH_FOR_GENERIC_PROVIDER_FAILURE";

export const SEARCH_FOR_GENERIC_PROVIDER_SLOT_AVAILABILITY = "SEARCH_FOR_GENERIC_PROVIDER_SLOTS";
export const SEARCH_FOR_GENERIC_PROVIDER_SLOT_AVAILABILITY_SUCCESS = "SEARCH_FOR_GENERIC_PROVIDER_SLOTS_SUCCESS";
export const SEARCH_FOR_GENERIC_PROVIDER_SLOT_AVAILABILITY_FAILURE = "SEARCH_FOR_GENERIC_PROVIDER_SLOTS_FAILURE";

export const BEGIN_AJAX_CALL = "BEGIN_AJAX_CALL";
export const AJAX_CALL_ERROR = "AJAX_CALL_ERROR";
export const APPLICATION_ERROR = "APPLICATION_ERROR";
export const INIT_SESSION = "INIT_SESSION";

export const NOTICES_NON_LOGGED_IN = "NOTICES_NON_LOGGED_IN";
export const NOTICES_LOGGED_IN = "NOTICES_LOGGED_IN";
export const NOTICES_NON_LOGGED_IN_HIDE = "NOTICES_NON_LOGGED_IN_HIDE";
export const NOTICES_LOGGED_IN_HIDE = "NOTICES_LOGGED_IN_HIDE";

export const USER_AUTHENTICATE = "USER_AUTHENTICATE";
export const USER_AUTHENTICATE_SUCCESS = "USER_AUTHENTICATE_SUCCESS";
export const USER_AUTHENTICATE_FAILURE = "USER_AUTHENTICATE_FAILURE";
export const USER_AUTHENTICATE_REFRESH = "USER_AUTHENTICATE_REFRESH";
export const USER_AUTHENTICATE_ISLOGGEDIN = "USER_AUTHENTICATE_ISLOGGEDIN";
export const ON_USER_AUTHENTICATE_SUCCESS = "ON_USER_AUTHENTICATE_SUCCESS";
export const UPDATE_TOKEN_AND_REFRESH_TOKEN = "UPDATE_TOKEN_AND_REFRESH_TOKEN";
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const LOGOUT_COMPLETED = "LOGOUT_COMPLETED";
export const VERIFY_LOGIN = "VERIFY_LOGIN";
export const VERIFY_LOGIN_COMPLETED = "VERIFY_LOGIN_COMPLETED";
export const REFRESH_TOKEN = "REFRESH_TOKEN";
export const REFRESH_TOKEN_FAILURE = "REFRESH_TOKEN_FAILURE";
export const USER_LOGGED_OUT = "USER_LOGGED_OUT";
export const SET_REDIRECT_URL = "SET_REDIRECT_URL";
export const CHECK_IS_LOGGED_IN = "CHECK_IS_LOGGED_IN";
export const LOGIN_FORM_SUCCESS = "LOGIN_FORM_SUCCESS";
export const CLEAR_USERLOGGEDOUT_MESSAGE = "CLEAR_USERLOGGEDOUT_MESSAGE";
export const CLEAR_LOGGEDOUT_MESSAGE = "CLEAR_LOGGEDOUT_MESSAGE";
export const CLEAR_REDIRECT_URL = "CLEAR_REDIRECT_URL";
export const REFRESH_FAMILY_MANAGEMENT_TOOLTIP = "REFRESH_FAMILY_MANAGEMENT_TOOLTIP";

export const PROXY_LIST_LOADING = "PROXY_LIST_LOADING";
export const PROXY_LIST_LOADED = "PROXY_LIST_LOADED";
export const NO_USER_PROXY = "NO_USER_PROXY";
export const PROXY_LIST_FAILURE = "PROXY_LIST_FAILURE";
export const USER_TO_SWITCH = "USER_TO_SWITCH";
export const SWITCH_USER_SAGA = "SWITCH_USER_SAGA";
export const SWITCH_USER_REDUCER = "SWITCH_USER_REDUCER";
export const SWITCH_TO_PHARMACY_USER = "SWITCH_TO_PHARMACY_USER";
export const SET_PHARMACY_LINKED = "SET_PHARMACY_LINKED";
export const RESET_USER_VALUE = "RESET_USER_VALUE";

export const LOAD_DASHBOARD_START = "LOAD_DASHBOARD_START";
export const LOAD_DASHBOARD_SUCCESS = "LOAD_DASHBOARD_SUCCESS";
export const LOAD_DASHBOARD_ERROR = "LOAD_DASHBOARD_ERROR";
export const INITIATE_TODOS = "INITIATE_TODOS";
export const TODOS_SUCCESS = "TODOS_SUCCESS";
export const TODOS_FAILURE = "TODOS_FAILURE";
export const SET_MEMBERSHIP_NOTI_RESPONSE = "SET_MEMBERSHIP_NOTI_RESPONSE";
export const LOAD_DASHBOARD_SEE_ALL_VIEW = "LOAD_DASHBOARD_SEE_ALL_VIEW";
export const RESET_DASHBOARD_SEE_ALL_VIEW = "RESET_DASHBOARD_SEE_ALL_VIEW";
export const INITIAL_STATE_DASHBOARD_SEE_ALL_VIEW = "INITIAL_STATE_DASHBOARD_SEE_ALL_VIEW";

export const LOAD_HEALTHPLANDASHBOARD_START = "LOAD_HEALTHPLANDASHBOARD_START";
export const LOAD_HEALTHPLANDASHBOARD_SUCCESS = "LOAD_HEALTHPLANDASHBOARD_SUCCESS";

export const THRIVE = "THRIVE";
export const EVISIT = "EVISIT";
export const EVISIT_GET_SUCCESS = "EVISIT_GET_SUCCESS";
export const EVISIT_GET_FAILURE = "EVISIT_GET_FAILURE";
export const FAQ = "FAQ";
export const FAQ_SUCCESS = "FAQ_SUCCESS";
export const FAQ_FAILURE = "FAQ_FAILURE";

export const LOAD_HEALTHSOURCEDASHBOARD_START = "LOAD_HEALTHSOURCEDASHBOARD_START";
export const LOAD_HEALTHSOURCEDASHBOARD_SUCCESS = "LOAD_HEALTHSOURCEDASHBOARD_SUCCESS";
export const REMOVE_SLIDE = "REMOVE_SLIDE";

export const LOAD_PHARMACYDASHBOARD_START = "LOAD_PHARMACYDASHBOARD_START";
export const LOAD_PHARMACYDASHBOARD_SUCCESS = "LOAD_PHARMACYDASHBOARD_SUCCESS";
export const LOAD_PHARMACYDASHBOARD_FAILURE = "LOAD_PHARMACYDASHBOARD_FAILURE";
export const GEOLOCATION = "GEOLOCATION";
export const GEOADDRESS = "GEOADDRESS";
export const GEOLOCATION_SUCCESS = "GEOLOCATION_SUCCESS";
export const GEOLOCATION_FAILURE = "GEOLOCATION_FAILURE";
export const GEOADDRESS_SUCCESS = "GEOADDRESS_SUCCESS";
export const GEOADDRESS_FAILURE = "GEOADDRESS_FAILURE";
export const CLOSEST_PHARMACY = "CLOSEST_PHARMACY";
export const CLOSEST_PHARMACY_SUCCESS = "CLOSEST_PHARMACY_SUCCESS";
export const CLOSEST_PHARMACY_FAILURE = "CLOSEST_PHARMACY_FAILURE";
export const LINK_PHARMACY_DIALOG_OPEN = "LINK_PHARMACY_DIALOG_OPEN";
export const LINK_PHARMACY_DIALOG_CLOSE = "LINK_PHARMACY_DIALOG_CLOSE";
export const LINK_PHARMACY = "LINK_PHARMACY";
export const LINK_PHARMACY_SUCCESS = "LINK_PHARMACY_SUCCESS";
export const LINK_PHARMACY_FAILURE = "LINK_PHARMACY_FAILURE";

export const RX_READY_FOR_PICKUP = "RX_READY_FOR_PICKUP";
export const RX_READY_FOR_PICKUP_SUCCESS = "RX_READY_FOR_PICKUP_SUCCESS";
export const RX_READY_FOR_PICKUP_FAILURE = "RX_READY_FOR_PICKUP_FAILURE";
export const RX_READY_FOR_REFILL_SUCCESS = "RX_READY_FOR_REFILL_SUCCESS";
export const RX_READY_FOR_REFILL_FAILURE = "RX_READY_FOR_REFILL_FAILURE";
export const RXTRANSFER_START = "RXTRANSFER_START";
export const EXTERNAL_RX_TRANSFER_START = "EXTERNAL_RX_TRANSFER_START";
export const EXTERNAL_RX_TRANSFER_SUCCESS = "EXTERNAL_RX_TRANSFER_SUCCESS";
export const EXTERNAL_RX_TRANSFER_FAILURE = "EXTERNAL_RX_TRANSFER_FAILURE";
export const PHARMACY_LIST_START = "PHARMACY_LIST_START";
export const PHARMACY_LIST_COMPLETED = "PHARMACY_LIST_COMPLETED";
export const RECENTPHARMACY_LIST_START = "RECENTPHARMACY_LIST_START";
export const RECENTPHARMACY_LIST_COMPLETED = "RECENTPHARMACY_LIST_COMPLETED";

export const LOAD_RX_LIST_START = "LOAD_RX_LIST_START";
export const LOAD_RX_LIST_COMPLETED = "LOAD_RX_LIST_COMPLETED";
export const RX_List_FAILURE = "RX_List_FAILURE";

export const LOAD_ARCHIVED_RX_LIST_START = "LOAD_ARCHIVED_RX_LIST_START";
export const ARCHIVE_UNARCHIVE_RX_START = "ARCHIVE_UNARCHIVE_RX_START";
export const ARCHIVE_UNARCHIVE_RX_SUCCESS = "ARCHIVE_UNARCHIVE_RX_SUCCESS";
export const ARCHIVE_UNARCHIVE_RX_FAILURE = "ARCHIVE_UNARCHIVE_RX_FAILURE";
export const LOAD_ARCHIVED_RX_LIST_COMPLETED = "LOAD_ARCHIVED_RX_LIST_COMPLETED";
export const RX_ARCHIVED_List_FAILURE = "RX_ARCHIVED_List_FAILURE";

export const RX_DETAIL = "RX_DETAIL";
export const RX_DETAIL_SUCCESS = "RX_DETAIL_SUCCESS";
export const RX_DETAIL_FAILURE = "RX_DETAIL_FAILURE";
export const RX_HISTORY = "RX_HISTORY";
export const RX_HISTORY_SUCCESS = "RX_HISTORY_SUCCESS";
export const RX_HISTORY_FAILURE = "RX_HISTORY_FAILURE";

export const UNLINK_RX_TRANSFER_START = "UNLINK_RX_TRANSFER_START";
export const UNLINK_RX_TRANSFER_SUCCESS = "UNLINK_RX_TRANSFER_SUCCESS";

export const SET_SERVER_DATA = "SET_SERVER_DATA";
export const SET_HISTORY_OBJECT = "SET_HISTORY_OBJECT";
export const UPDATE_PATIENT_IDS = "UPDATE_PATIENT_IDS";

export const LOAD_ORDERREFILLS_LIST_START = "LOAD_ORDERREFILLS_LIST_START";
export const LOAD_ORDERREFILLS_LIST_COMPLETED = "LOAD_ORDERREFILLS_LIST_COMPLETED";
export const LOAD_ORDERREFILLS_LIST_FAILURE = "LOAD_ORDERREFILLS_LIST_FAILURE";
export const ORDER_REFILL_LIST_UPDATE = "ORDER_REFILL_LIST_UPDATE";

export const LOAD_PICKUP_HOURS_START = "LOAD_PICKUP_HOURS_START";
export const LOAD_PICKUP_HOURS_COMPLETED = "LOAD_PICKUP_HOURS_COMPLETED";

export const SUBMIT_IVR_START = "SUBMIT_IVR_START";
export const SUBMIT_IVR_ORDER_REQUEST = "SUBMIT_IVR_ORDER_REQUEST";
export const SUBMIT_IVR_ORDER_COMPLETED = "SUBMIT_IVR_ORDER_COMPLETED";

export const INTERNAL_RX_TRANSFER_START = "INTERNAL_RX_TRANSFER_START";
export const INTERNAL_RX_TRANSFER_COMPLETED = "INTERNAL_RX_TRANSFER_COMPLETED";
export const INTERNAL_RX_TRANSFER_FAILURE = "INTERNAL_RX_TRANSFER_FAILURE";

export const GET_PHARMACY_BY_STORENUMBER_START = "GET_PHARMACY_BY_STORENUMBER_START";
export const GET_PHARMACY_BY_STORENUMBER_COMPLETED = "GET_PHARMACY_BY_STORENUMBER_COMPLETED";


export const MAP__CLOSE_INFO_WINDOW = "MAP__CLOSE_INFO_WINDOW";

export const MAP__OPEN_MODAL_WINDOW = "MAP__OPEN_MODAL_WINDOW";

export const MAP__CLOSE_MODAL_WINDOW = "MAP__CLOSE_MODAL_WINDOW";

export const SET_FAVOURITE_PHARMACY_START = "SET_FAVOURITE_PHARMACY_START";
export const SET_FAVOURITE_PHARMACY_SUCCESS = "SET_FAVOURITE_PHARMACY_SUCCESS";

export const OPEN_SCHEDULE_PROVIDER = "OPEN_SCHEDULE_PROVIDER";
export const OPEN_SCHEDULE_PROVIDER_SUCCESS = "OPEN_SCHEDULE_PROVIDER_SUCCESS";
export const OPEN_SCHEDULE_PROVIDER_FAILED = "OPEN_SCHEDULE_PROVIDER_FAILED";
export const OPEN_SCHEDULE_PROVIDER_PENDING = "OPEN_SCHEDULE_PROVIDER_PENDING";
export const OPEN_SCHEDULE_PROV_LOC = "OPEN_SCHEDULE_PROV_LOC";
export const OPEN_SCHEDULE_PROV_LOC_SUCCESS = "OPEN_SCHEDULE_PROV_LOC_SUCCESS";
export const OPEN_SCHEDULE_AVAILABILITY = "OPEN_SCHEDULE_AVAILABILITY";
export const OPEN_SCHEDULE_AVAILABILITY_SUCCESS = "OPEN_SCHEDULE_AVAILABILITY_SUCCESS";
export const OPEN_SCHEDULE_SCHEDULE = "OPEN_SCHEDULE_SCHEDULE";
export const OPEN_SCHEDULE_SCHEDULE_SUCCESS = "OPEN_SCHEDULE_SCHEDULE_SUCCESS";
export const OPEN_SCHEDULE_SCHEDULE_FAILED = "OPEN_SCHEDULE_SCHEDULE_FAILED";
export const OPEN_SCHEDULE_SCHEDULE_PENDING = "OPEN_SCHEDULE_SCHEDULE_PENDING";
export const OPEN_SCHEDULE_VISIT_TYPE_LOCATION = "OPEN_SCHEDULE_VISIT_TYPE_LOCATION";
export const OPEN_SCHEDULE_VISIT_TYPE_LOCATION_RUNNING = "OPEN_SCHEDULE_VISIT_TYPE_LOCATION_RUNNING";
export const OPEN_SCHEDULE_VISIT_TYPE_LOCATION_SUCCESS = "OPEN_SCHEDULE_VISIT_TYPE_LOCATION_SUCCESS";
export const OPEN_SCHEDULE_VISIT_TYPE_LOCATION_FAILED = "OPEN_SCHEDULE_VISIT_TYPE_LOCATION_FAILED";
export const OPEN_SCHEDULE_EARLIEST = "OPEN_SCHEDULE_EARLIEST";
export const OPEN_SCHEDULE_EARLIEST_SUCCESS = "OPEN_SCHEDULE_EARLIEST_SUCCESS";
export const OPEN_SCHEDULE_EARLIEST_FAILURE = "OPEN_SCHEDULE_EARLIEST_FAILURE";
export const OPEN_SCHEDULE_ARRIVAL_TIME = "OPEN_SCHEDULE_ARRIVAL_TIME";
export const OPEN_SCHEDULE_ARRIVAL_TIME_SUCCESS = "OPEN_SCHEDULE_ARRIVAL_TIME_SUCCESS";
export const OPEN_SCHEDULE_ARRIVAL_TIME_FAILURE = "OPEN_SCHEDULE_ARRIVAL_TIME_FAILURE";
export const OPEN_SCHEDULE_PROVIDER_LIST = "OPEN_SCHEDULE_PROVIDER_LIST";
export const OPEN_SCHEDULE_PROVIDER_LIST_SUCCESS = "OPEN_SCHEDULE_PROVIDER_LIST_SUCCESS";
export const OPEN_SCHEDULE_CREATE_PATIENT = "OPEN_SCHEDULE_CREATE_PATIENT";
export const OPEN_SCHEDULE_CREATE_AND_SCHEDULE = "OPEN_SCHEDULE_CREATE_AND_SCHEDULE";
export const OPEN_SCHEDULE_CREATE_PATIENT_SUCCESS = "OPEN_SCHEDULE_CREATE_PATIENT_SUCCESS";
export const OPEN_SCHEDULE_CREATE_PATIENT_FAILED = "OPEN_SCHEDULE_CREATE_PATIENT_FAILED";
export const OPEN_SCHEDULE_CLEAR_REDUX_STATE = "OPEN_SCHEDULE_CLEAR_REDUX_STATE";
export const RESET_SELECTED_MAPS_VALUE = "RESET_SELECTED_MAPS_VALUE";
export const CURRENT_LOCATION_ZIPCODE = "CURRENT_LOCATION_ZIPCODE";
export const UPDATE_BYPASS_PROXY_AND_INFO = "UPDATE_BYPASS_PROXY_AND_INFO";
export const OPEN_SCHEDULE_MAMMOGRAM_QUESTIONS = "OPEN_SCHEDULE_MAMMOGRAM_QUESTIONS";
export const OPEN_SCHEDULE_MAMMOGRAM_QUESTIONS_SUCCESS = "OPEN_SCHEDULE_MAMMOGRAM_QUESTIONS_SUCCESS";
export const OPEN_SCHEDULE_MAMMOGRAM_QUESTIONS_FAILURE = "OPEN_SCHEDULE_MAMMOGRAM_QUESTIONS_FAILURE";
export const OPEN_SCHEDULE_MAMMOGRAM_ANSWERS_SUCCESS = "OPEN_SCHEDULE_MAMMOGRAM_ANSWERS_SUCCESS";
export const OPEN_SCHEDULE_MAMMOGRAM_ANSWERS_FAILURE = "OPEN_SCHEDULE_MAMMOGRAM_ANSWERS_FAILURE";
export const OPEN_SCHEDULE_MAMMOGRAM_ANSWERS = "OPEN_SCHEDULE_MAMMOGRAM_ANSWERS";
export const OPEN_SCHEDULE_QUESTIONS_RESPONSE_SUCCESS = "OPEN_SCHEDULE_QUESTIONS_RESPONSE_SUCCESS";
export const OPEN_SCHEDULE_QUESTIONS_RESPONSE_FAILURE = "OPEN_SCHEDULE_QUESTIONS_RESPONSE_FAILURE";
export const OPEN_SCHEDULE_QUESTIONS_RESPONSE = "OPEN_SCHEDULE_QUESTIONS_RESPONSE";
export const OPEN_SCHEDULE_RESET_MAMMOGRAM_QUESTION_CURRENT_RESPONSE = "OPEN_SCHEDULE_RESET_MAMMOGRAM_QUESTION_CURRENT_RESPONSE";
export const OPEN_SCHEDULE_RESET_MAMMOGRAM_QUESTION_CURRENT_RESPONSE_COMPLETED = "OPEN_SCHEDULE_RESET_MAMMOGRAM_QUESTION_CURRENT_RESPONSE_COMPLETED";

export const CHANGE_USERNAME = "CHANGE_USERNAME";
export const CHANGE_USERNAME_SUCCESS = "CHANGE_USERNAME_SUCCESS";
export const CHANGE_USERNAME_FAILURE = "CHANGE_USERNAME_FAILURE";
export const CHANGE_USERNAME_CLEAR = "CHANGE_USERNAME_CLEAR";

export const CHANGE_EMAIL_START = "CHANGE_EMAIL_START";
export const CHANGE_EMAIL_SUCCESS = "CHANGE_EMAIL_SUCCESS";
export const CHANGE_EMAIL_FAILURE = "CHANGE_EMAIL_FAILURE";
export const CHANGE_EMAIL_CLEAR_MESSAGE = "CHANGE_EMAIL_CLEAR_MESSAGE";

export const CHANGE_PASSWORD = "CHANGE_PASSWORD";
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_FAILURE = "CHANGE_PASSWORD_FAILURE";
export const CHANGE_PASSWORD_CLEAR = "CHANGE_PASSWORD_CLEAR";

export const FORGOT_PASSWORD_START = "FORGOT_PASSWORD_START";
export const FORGOT_PASSWORD_SUCCESS = "FORGOT_PASSWORD_SUCCESS";
export const FORGOT_PASSWORD_FAILURE = "FORGOT_PASSWORD_FAILURE";
export const FORGOT_PASSWORD_CLEAR = "FORGOT_PASSWORD_CLEAR";

export const RESET_PASSWORD_START = "RESET_PASSWORD_START";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_FAILURE = "RESET_PASSWORD_FAILURE";

export const LINK_EMPLOYEE_ACCOUNT_START = "LINK_EMPLOYEE_ACCOUNT_START";
export const LINK_EMPLOYEE_ACCOUNT_SUCCESS = "LINK_EMPLOYEE_ACCOUNT_SUCCESS";
export const LINK_EMPLOYEE_ACCOUNT_FAILURE = "LINK_EMPLOYEE_ACCOUNT_FAILURE";
export const LINK_EMPLOYEE_CLEAR_MESSAGE = "LINK_EMPLOYEE_CLEAR_MESSAGE";

export const UNLINK_EMPLOYEE_ACCOUNT_START = "UNLINK_EMPLOYEE_ACCOUNT_START";
export const UNLINK_EMPLOYEE_ACCOUNT_SUCCESS = "UNLINK_EMPLOYEE_ACCOUNT_SUCCESS";
export const UNLINK_EMPLOYEE_ACCOUNT_FAILURE = "UNLINK_EMPLOYEE_ACCOUNT_FAILURE";
export const UNLINK_EMPLOYEE_CLEAR_MESSAGE = "UNLINK_EMPLOYEE_CLEAR_MESSAGE";

export const LINK_MYCHART_ACCOUNT_START = "LINK_MYCHART_ACCOUNT_START";
export const LINK_MYCHART_ACCOUNT_SUCCESS = "LINK_MYCHART_ACCOUNT_SUCCESS";
export const LINK_MYCHART_ACCOUNT_FAILURE = "LINK_MYCHART_ACCOUNT_FAILURE";
export const LINK_MYCHART_CLEAR_MESSAGE = "LINK_MYCHART_CLEAR_MESSAGE";

export const UNLINK_MYCHART_ACCOUNT_START = "UNLINK_MYCHART_ACCOUNT_START";
export const UNLINK_MYCHART_ACCOUNT_SUCCESS = "UNLINK_MYCHART_ACCOUNT_SUCCESS";
export const UNLINK_MYCHART_ACCOUNT_FAILURE = "UNLINK_MYCHART_ACCOUNT_FAILURE";
export const UNLINK_MYCHART_CLEAR_MESSAGE = "UNLINK_MYCHART_CLEAR_MESSAGE";

export const RX_DEFAULT_PHARMACY_FAILURE = "RX_DEFAULT_PHARMACY_FAILURE";
export const GET_PHARMACY_BY_STORENUMBER_FAILURE = "GET_PHARMACY_BY_STORENUMBER_FAILURE";
export const SUBMIT_IVR_ORDER_FAILURE = "SUBMIT_IVR_ORDER_FAILURE";
export const LOAD_PICKUP_HOURS_FAILURE = "LOAD_PICKUP_HOURS_FAILURE";
export const UNLINK_RX_TRANSFER_FAILURE = "UNLINK_RX_TRANSFER_FAILURE";
export const RECENTPHARMACY_LIST_FAILURE = "RECENTPHARMACY_LIST_FAILURE";
export const CITY_ZIP_LIST = "CITY_ZIP_LIST";
export const CITY_ZIP_LIST_SUCCESS = "CITY_ZIP_LIST_SUCCESS";
export const CITY_ZIP_LIST_FAILURE = "CITY_ZIP_LIST_FAILURE";
export const CITIES_LIST_FAILURE = "CITIES_LIST_FAILURE";
export const RXTRANSFER_FAILURE = "RXTRANSFER_FAILURE";
export const SET_FAVOURITE_PHARMACY_FAILURE = "SET_FAVOURITE_PHARMACY_FAILURE";

export const SET_PROGRESS_FORWARD = "SET_PROGRESS_FORWARD";
export const RESET_LOGIN_SETTINGS_DATA = "RESET_LOGIN_SETTINGS_DATA";

export const ARCHIVE_UNLINKED_RX_TRANSFER_START = "ARCHIVE_UNLINKED_RX_TRANSFER_START";
export const ARCHIVE_UNLINKED_RX_TRANSFER_SUCCESS = "ARCHIVE_UNLINKED_RX_TRANSFER_SUCCESS";
export const ARCHIVE_UNLINKED_RX_TRANSFER_FAILURE = "ARCHIVE_UNLINKED_RX_TRANSFER_FAILURE";

export const GET_FAVORITE_PROVIDERS_START = "GET_FAVORITE_PROVIDERS_START";
export const GET_FAVORITE_PROVIDERS_SUCCESS = "GET_FAVORITE_PROVIDERS_SUCCESS";
export const GET_FAVORITE_PROVIDERS_FAILURE = "GET_FAVORITE_PROVIDERS_FAILURE";


export const GET_RECENT_VISITED_DOCTORS_START = "GET_RECENT_VISITED_DOCTORS_START";
export const GET_RECENT_VISITED_DOCTORS_SUCCESS = "GET_RECENT_VISITED_DOCTORS_SUCCESS";
export const GET_RECENT_VISITED_DOCTORS_FAILURE = "GET_RECENT_VISITED_DOCTORS_FAILURE";

export const FORGOT_USERNAME_START = "FORGOT_USERNAME_START";
export const FORGOT_USERNAME_SUCCESS = "FORGOT_USERNAME_SUCCESS";
export const FORGOT_USERNAME_FAILURE = "FORGOT_USERNAME_FAILURE";
export const FORGOT_USERNAME_CLEAR = "FORGOT_USERNAME_CLEAR";

export const LOAD_DOCS_DATA = "LOAD_DOCS_DATA";
export const LOAD_DOCS_DATA_SUCCESS = "LOAD_DOCS_DATA_SUCCESS";
export const LOAD_DOCS_DATA_FAILURE = "LOAD_DOCS_DATA_FAILURE";

export const REMOVE_FAVORITE_PROVIDER_START = "REMOVE_FAVORITE_PROVIDER_START";
export const REMOVE_FAVORITE_PROVIDER_SUCCESS = "REMOVE_FAVORITE_PROVIDER_SUCCESS";
export const REMOVE_FAVORITE_PROVIDER_FAILURE = "REMOVE_FAVORITE_PROVIDER_FAILURE";

export const ADD_FAVORITE_PROVIDER_START = "ADD_FAVORITE_PROVIDER_START";
export const ADD_FAVORITE_PROVIDER_SUCCESS = "ADD_FAVORITE_PROVIDER_SUCCESS";
export const ADD_FAVORITE_PROVIDER_FAILURE = "ADD_FAVORITE_PROVIDER_FAILURE";

export const LOAD_MYCHART_TERMS_DATA_START = "LOAD_MYCHART_TERMS_DATA_START";
export const LOAD_MYCHART_TERMS_DATA_SUCCESS = "LOAD_MYCHART_TERMS_DATA_SUCCESS";
export const LOAD_MYCHART_TERMS_DATA_FAILURE = "LOAD_MYCHART_TERMS_DATA_FAILURE";

export const SET_TERMS_AND_CONDITIONS = "SET_TERMS_AND_CONDITIONS";
export const LOAD_TERMS_AND_CONDITIONS = "LOAD_TERMS_AND_CONDITIONS";
export const ACCEPT_TERMS_AND_CONDITIONS = "ACCEPT_TERMS_AND_CONDITIONS";

export const SHOW_MARKETING_EMAIL_OPT_IN = "SHOW_MARKETING_EMAIL_OPT_IN"
export const SET_MARKETING_EMAIL_OPT_IN = "SET_MARKETING_EMAIL_OPT_IN"
export const SET_MARKETING_EMAIL_OPT_IN_SUCCESS = "SET_MARKETING_EMAIL_OPT_IN_SUCCESS"
export const SET_MARKETING_EMAIL_OPT_IN_FAILURE = "SET_MARKETING_EMAIL_OPT_IN_FAILURE"
export const UPDATE_SEEN_MARKETING_EMAIL_OPT_IN = "UPDATE_SEEN_MARKETING_EMAIL_OPT_IN"

export const PHARMACY_PROXY_INFO = "pharmacyProxyInfo";
export const PHARMACY_PROXY_REQUEST = "pharmacyProxyRequest";
export const PHARMACY_PROXY_REQUEST_DATA = "pharmacyProxyRequestData";
export const PHARMACY_PROXY_RESEND_REQUEST = "pharmacyProxyResendRequest";
export const PHARMACY_PROXY_REMOVE = "pharmacyProxyRemove";
export const PHARMACY_PROXY_APPROVE = "pharmacyProxyApprove";
export const PHARMACY_PROXY_DECLINE = "pharmacyProxyDecline";
export const PHARMACY_PROXY_ACCESS_LIST = "pharmacyProxyAccessList";
export const PHARMACY_PROXY_GRANT = "pharmacyProxyGrant";
export const HEALTH_RECORD_PROXY_REQUEST = "healthRecordProxyRequest";
export const PROXY_REQUEST_DATA = "hrp_proxyRequestData";

export const MYCHART_PROXY_REQUEST = "mychartProxyRequest";

export const PHARMACY_NOTIFICATION_PREFERENCE_SAVE = "pharmacyNotificationPreferenceSave";

export const GET_CARETEAM_PROVIDERS_START = "GET_CARETEAM_PROVIDERS_START";
export const GET_CARETEAM_PROVIDERS_SUCCESS = "GET_CARETEAM_PROVIDERS_SUCCESS";
export const GET_CARETEAM_PROVIDERS_FAILURE = "GET_CARETEAM_PROVIDERS_FAILURE";

export const SET_PROVIDER_DETAILS_NPI_LISTS = "SET_PROVIDER_DETAILS_NPI_LISTS";
export const SET_PROVIDER_DETAILS_FROM_NPI_LIST = "SET_PROVIDER_DETAILS_FROM_NPI_LIST";
export const SET_PARSED_PROVIDER_DETAILS_LISTS = "SET_PARSED_PROVIDER_DETAILS_LISTS";

export const GET_USER_PHONE_NUMBER_START = "GET_USER_PHONE_NUMBER_START";
export const GET_USER_PHONE_NUMBER_SUCCESS = "GET_USER_PHONE_NUMBER_SUCCESS";
export const GET_USER_PHONE_NUMBER_FAILURE = "GET_USER_PHONE_NUMBER_FAILURE";

export const ADD_OR_UPDATE_USER_PHONE_NUMBER_START = "ADD_OR_UPDATE_USER_PHONE_NUMBER_START";
export const ADD_OR_UPDATE_USER_PHONE_NUMBER_SUCCESS = "ADD_OR_UPDATE_USER_PHONE_NUMBER_SUCCESS";
export const ADD_OR_UPDATE_USER_PHONE_NUMBER_FAILURE = "ADD_OR_UPDATE_USER_PHONE_NUMBER_FAILURE";

export const GET_USER_ADDRESS_START = "GET_USER_ADDRESS_START";
export const GET_USER_ADDRESS_SUCCESS = "GET_USER_ADDRESS_SUCCESS";
export const GET_USER_ADDRESS_FAILURE = "GET_USER_ADDRESS_FAILURE";

export const GET_LAT_LNG_USER_ADDRESS_START = "GET_LAT_LNG_USER_ADDRESS_START";
export const GET_LAT_LNG_USER_ADDRESS_SUCCESS = "GET_LAT_LNG_USER_ADDRESS_SUCCESS";
export const GET_LAT_LNG_USER_ADDRESS_FAILURE = "GET_LAT_LNG_USER_ADDRESS_FAILURE";

export const RELOAD_KEY = "RELOAD_KEY";

export const SET_USER_PREFERENCES = "SET_USER_PREFERENCES";
export const GET_USER_PREFERENCE = "GetUserPreference";
export const GET_USER_PREFERENCE_SUCCESS = "GetUserPreference.Success";
export const GET_USER_PREFERENCE_FAILURE = "GetUserPreference.Failure";
export const UPDATE_USER_PREFERENCE = "UpdateUserPreference";
export const UPDATE_USER_PREFERENCE_SUCCESS = "UpdateUserPreference.Success";
export const UPDATE_USER_PREFERENCE_FAILURE = "UpdateUserPreference.Failure";

export const SET_HIDE_TUTORIAL = "SET_HIDE_TUTORIAL";
export const SAVE_HIDE_TUTORIAL = "SAVE_HIDE_TUTORIAL";

export const SUBMIT_USER_FEEDBACK_FORM = "SUBMIT_USER_FEEDBACK_FORM";

export const DIRECT_SCHEDULING_PROVIDER_LIST = "DIRECT_SCHEDULING_PROVIDER_LIST";
export const DIRECT_SCHEDULING_PROVIDER_LIST_SUCCESS = "DIRECT_SCHEDULING_PROVIDER_LIST_SUCCESS";
export const DIRECT_SCHEDULING_PROVIDER_LIST_FAILURE = "DIRECT_SCHEDULING_PROVIDER_LIST_FAILURE";

export const CONSENT_GET_FLU = "CONSENT_GET_FLU";
export const CONSENT_GET_SUCCESS = "CONSENT_GET_SUCCESS";
export const CONSENT_GET_FAILURE = "CONSENT_GET_FAILURE";
export const CONSENT_GET_PENDING = "CONSENT_GET_PENDING";
export const CONSENT_GET_LIST = "CONSENT_GET_LIST";
export const CONSENT_GET_LIST_SUCCESS = "CONSENT_GET_LIST_SUCCESS";
export const CONSENT_GET_LIST_FAILURE = "CONSENT_GET_LIST_FAILURE";

export const CONSENT_FLU_PENDING = "CONSENT_FLU_PENDING";
export const CONSENT_FLU_SUCCESS = "CONSENT_FLU_SUCCESS";
export const CONSENT_FLU_FAILURE = "CONSENT_FLU_FAILURE";

export const CONSENT_SET_FLU = "CONSENT_SET_FLU";
export const CONSENT_SET_SUCCESS = "CONSENT_SET_SUCCESS";
export const CONSENT_SET_FAILURE = "CONSENT_SET_FAILURE";
export const CONSENT_SET_PENDING = "CONSENT_SET_PENDING";

export const CONSENT_TYPE_GET = "CONSENT_TYPE_GET";
export const CONSENT_TYPE_PENDING = "CONSENT_TYPE_PENDING";
export const CONSENT_TYPE_SUCCESS = "CONSENT_TYPE_SUCCESS";
export const CONSENT_TYPE_FAILURE = "CONSENT_TYPE_FAILURE";

export const CONSENT_TYPE_LIST_GET = "CONSENT_TYPE_LIST_GET";
export const CONSENT_TYPE_LIST_PENDING = "CONSENT_TYPE_LIST_PENDING";
export const CONSENT_TYPE_LIST_SUCCESS = "CONSENT_TYPE_LIST_SUCCESS";
export const CONSENT_TYPE_LIST_FAILURE = "CONSENT_TYPE_LIST_FAILURE";

export const GET_COMPLETE_FLU_STATUS = "GET_COMPLETE_FLU_STATUS";
export const GET_COMPLETE_FLU_STATUS_PENDING = "GET_COMPLETE_FLU_STATUS_PENDING";
export const GET_COMPLETE_FLU_STATUS_SUCCESS = "GET_COMPLETE_FLU_STATUS_SUCCESS";
export const GET_COMPLETE_FLU_STATUS_FAILURE = "GET_COMPLETE_FLU_STATUS_FAILURE";

export const DISABLE_FLU = "DISABLE_FLU";
export const DISMISS_FLU_TILE = "DISMISS_FLU_TILE";
export const HIDE_FLU_VACCINE_TILE = "HIDE_FLU_VACCINE_TILE";

export const STAY_ON_INCOMPLETE_FORM = "STAY_ON_INCOMPLETE_FORM";

export const SITE_SEARCH_START = "SITE_SEARCH_START";
export const SITE_SEARCH_SUCCESS = "SITE_SEARCH_SUCCESS";
export const SITE_SEARCH_FAILURE = "SITE_SEARCH_FAILURE";

export const PATIENT_PHOTO_START = "PATIENT_PHOTO_START";
export const PATIENT_PHOTO_SUCCESS = "PATIENT_PHOTO_SUCCESS";
export const PATIENT_PHOTO_FAILURE = "PATIENT_PHOTO_FAILURE";

export const THRIVE_GET_CARD = "THRIVE_GET_CARD";
export const THRIVE_GET_CARD_SUCCESS = "THRIVE_GET_CARD_SUCCESS";
export const THRIVE_GET_CARD_PENDING = "THRIVE_GET_CARD_PENDING";
export const THRIVE_GET_CARD_FAILURE = "THRIVE_GET_CARD_FAILURE";

export const THRIVE_GET_REPORT = "THRIVE_GET_REPORT";
export const THRIVE_GET_REPORT_SUCCESS = "THRIVE_GET_REPORT_SUCCESS";
export const THRIVE_GET_REPORT_PENDING = "THRIVE_GET_REPORT_PENDING";
export const THRIVE_GET_REPORT_FAILURE = "THRIVE_GET_REPORT_FAILURE";

export const HP_GET_OTHER_COVERAGE_START = "HP_GET_OTHER_COVERAGE_START";
export const HP_GET_OTHER_COVERAGE_SUCCESS = "HP_GET_OTHER_COVERAGE_SUCCESS";
export const HP_GET_OTHER_COVERAGE_FAILURE = "HP_GET_OTHER_COVERAGE_FAILURE";

export const HP_UPDATE_OTHER_COVERAGE_START = "HP_UPDATE_OTHER_COVERAGE_START";
export const HP_UPDATE_OTHER_COVERAGE_SUCCESS = "HP_UPDATE_OTHER_COVERAGE_SUCCESS";
export const HP_UPDATE_OTHER_COVERAGE_FAILURE = "HP_UPDATE_OTHER_COVERAGE_FAILURE";

export const HP_GET_NOTIFICATION_PREFERENCES_START = "HP_GET_NOTIFICATION_PREFERENCES_START";
export const HP_GET_NOTIFICATION_PREFERENCES_SUCCESS = "HP_GET_NOTIFICATION_PREFERENCES_SUCCESS";
export const HP_GET_NOTIFICATION_PREFERENCES_FAILURE = "HP_GET_NOTIFICATION_PREFERENCES_FAILURE";

export const HP_UPDATE_NOTIFICATION_PREFERENCES_START = "HP_UPDATE_NOTIFICATION_PREFERENCES_START";
export const HP_UPDATE_NOTIFICATION_PREFERENCES_SUCCESS = "HP_UPDATE_NOTIFICATION_PREFERENCES_SUCCESS";
export const HP_UPDATE_NOTIFICATION_PREFERENCES_FAILURE = "HP_UPDATE_NOTIFICATION_PREFERENCES_FAILURE";

export const HP_TRIGGER_PAPER_DOCUMENT_START = "HP_TRIGGER_PAPER_DOCUMENT_START";
export const HP_TRIGGER_PAPER_DOCUMENT_SUCCESS = "HP_TRIGGER_PAPER_DOCUMENT_SUCCESS";
export const HP_TRIGGER_PAPER_DOCUMENT_FAILURE = "HP_TRIGGER_PAPER_DOCUMENT_FAILURE";

export const HP_GET_SUPPORT_NOTIFICATION_START = "HP_GET_SUPPORT_NOTIFICATION_START";
export const HP_GET_SUPPORT_NOTIFICATION_SUCCESS = "HP_GET_SUPPORT_NOTIFICATION_SUCCESS";
export const HP_GET_SUPPORT_NOTIFICATION_FAILURE = "HP_GET_SUPPORT_NOTIFICATION_FAILURE";

export const HP_GET_BENEFIT_PLANS_START = "HP_GET_BENEFIT_PLANS_START";
export const HP_GET_BENEFIT_PLANS_SUCCESS = "HP_GET_BENEFIT_PLANS_SUCCESS";
export const HP_GET_BENEFIT_PLANS_FAILURE = "HP_GET_BENEFIT_PLANS_FAILURE";

export const HP_GET_BENEFIT_DOCUMENTS_START = "HP_GET_BENEFIT_DOCUMENTS_START";
export const HP_GET_BENEFIT_DOCUMENTS_SUCCESS = "HP_GET_BENEFIT_DOCUMENTS_SUCCESS";
export const HP_GET_BENEFIT_DOCUMENTS_FAILURE = "HP_GET_BENEFIT_DOCUMENTS_FAILURE";

export const HP_GET_BENEFIT_DOCUMENT_START = "HP_GET_BENEFIT_DOCUMENT_START";
export const HP_GET_BENEFIT_DOCUMENT_SUCCESS = "HP_GET_BENEFIT_DOCUMENT_SUCCESS";
export const HP_GET_BENEFIT_DOCUMENT_FAILURE = "HP_GET_BENEFIT_DOCUMENT_FAILURE";

export const HP_SSO_PHARMACY_START = "HP_SSO_PHARMACY_START";
export const HP_SSO_PHARMACY_SUCCESS = "HP_SSO_PHARMACY_SUCCESS";
export const HP_SSO_PHARMACY_FAILURE = "HP_SSO_PHARMACY_FAILURE";

export const HP_SSO_NATURALLYSLIM_START = "HP_SSO_NATURALLYSLIM_START";
export const HP_SSO_NATURALLYSLIM_SUCCESS = "HP_SSO_NATURALLYSLIM_SUCCESS";
export const HP_SSO_NATURALLYSLIM_FAILURE = "HP_SSO_NATURALLYSLIM_FAILURE";

export const HP_SSO_FIRSTCAREPLUS_START = "HP_SSO_FIRSTCAREPLUS_START";
export const HP_SSO_FIRSTCAREPLUS_SUCCESS = "HP_SSO_FIRSTCAREPLUS_SUCCESS";
export const HP_SSO_FIRSTCAREPLUS_FAILURE = "HP_SSO_FIRSTCAREPLUS_FAILURE";

export const HP_SSO_THRIVE_START = "HP_SSO_THRIVE_START";
export const HP_SSO_THRIVE_SUCCESS = "HP_SSO_THRIVE_SUCCESS";
export const HP_SSO_THRIVE_FAILURE = "HP_SSO_THRIVE_FAILURE";

export const HP_SSO_INVOICESANDPAYMENTS_START = "HP_SSO_INVOICESANDPAYMENTS_START";
export const HP_SSO_INVOICESANDPAYMENTS_SUCCESS = "HP_SSO_INVOICESANDPAYMENTS_SUCCESS";
export const HP_SSO_INVOICESANDPAYMENTS_FAILURE = "HP_SSO_INVOICESANDPAYMENTS_FAILURE";

export const HP_SSO_TELEMEDICINE_START = "HP_SSO_TELEMEDICINE_START";
export const HP_SSO_TELEMEDICINE_SUCCESS = "HP_SSO_TELEMEDICINE_SUCCESS";
export const HP_SSO_TELEMEDICINE_FAILURE = "HP_SSO_TELEMEDICINE_FAILURE";

export const HP_GET_ACCUMULATOR_DATA = "HP_GET_ACCUMULATOR_DATA";
export const HP_GET_ACCUMULATOR_DATA_START = "HP_GET_ACCUMULATOR_DATA_START";
export const HP_GET_ACCUMULATOR_DATA_SUCCESS = "HP_GET_ACCUMULATOR_DATA_SUCCESS";
export const HP_GET_ACCUMULATOR_DATA_FAILURE = "HP_GET_ACCUMULATOR_DATA_FAILURE";

export const HP_GET_AUTHORIZATIONS_LIST = "HP_GET_AUTHORIZATIONS_LIST";
export const HP_GET_AUTHORIZATIONS_LIST_START = "HP_GET_AUTHORIZATIONS_LIST_START";
export const HP_GET_AUTHORIZATIONS_LIST_SUCCESS = "HP_GET_AUTHORIZATIONS_LIST_SUCCESS";
export const HP_GET_AUTHORIZATIONS_LIST_FAILURE = "HP_GET_AUTHORIZATIONS_LIST_FAILURE";

export const HP_GET_AUTHORIZATION_DETAIL = "HP_GET_AUTHORIZATION_DETAIL";
export const HP_GET_AUTHORIZATION_DETAIL_START = "HP_GET_AUTHORIZATION_DETAIL_START";
export const HP_GET_AUTHORIZATION_DETAIL_SUCCESS = "HP_GET_AUTHORIZATION_DETAIL_SUCCESS";
export const HP_GET_AUTHORIZATION_DETAIL_FAILURE = "HP_GET_AUTHORIZATION_DETAIL_FAILURE";

export const HP_GET_AUTHORIZATION_APPROVAL_LETTER = "HP_GET_AUTHORIZATION_APPROVAL_LETTER";
export const HP_GET_AUTHORIZATION_APPROVAL_LETTER_START = "HP_GET_AUTHORIZATION_APPROVAL_LETTER_START";
export const HP_GET_AUTHORIZATION_APPROVAL_LETTER_SUCCESS = "HP_GET_AUTHORIZATION_APPROVAL_LETTER_SUCCESS";
export const HP_GET_AUTHORIZATION_APPROVAL_LETTER_FAILURE = "HP_GET_AUTHORIZATION_APPROVAL_LETTER_FAILURE";

export const HP_GET_CLAIMS_LIST = "HP_GET_CLAIMS_LIST";
export const HP_GET_CLAIMS_LIST_START = "HP_GET_CLAIMS_LIST_START";
export const HP_GET_CLAIMS_LIST_SUCCESS = "HP_GET_CLAIMS_LIST_SUCCESS";
export const HP_GET_CLAIMS_LIST_FAILURE = "HP_GET_CLAIMS_LIST_FAILURE";

export const HP_GET_CLAIM_DETAIL = "HP_GET_CLAIM_DETAIL";
export const HP_GET_CLAIM_DETAIL_START = "HP_GET_CLAIM_DETAIL_START";
export const HP_GET_CLAIM_DETAIL_SUCCESS = "HP_GET_CLAIM_DETAIL_SUCCESS";
export const HP_GET_CLAIM_DETAIL_FAILURE = "HP_GET_CLAIM_DETAIL_FAILURE";

export const HP_GET_CRM_MEMBER_MESSAGES = "HP_GET_CRM_MEMBER_MESSAGES";
export const HP_GET_CRM_MEMBER_MESSAGES_START = "HP_GET_CRM_MEMBER_MESSAGES_START";
export const HP_GET_CRM_MEMBER_MESSAGES_SUCCESS = "HP_GET_CRM_MEMBER_MESSAGES_SUCCESS";
export const HP_GET_CRM_MEMBER_MESSAGES_FAILURE = "HP_GET_CRM_MEMBER_MESSAGES_FAILURE";

export const HP_SUBMIT_CLAIM_APPEAL = "HP_SUBMIT_CLAIM_APPEAL";
export const HP_SUBMIT_CLAIM_APPEAL_START = "HP_SUBMIT_CLAIM_APPEAL_START";
export const HP_SUBMIT_CLAIM_APPEAL_SUCCESS = "HP_SUBMIT_CLAIM_APPEAL_SUCCESS";
export const HP_SUBMIT_CLAIM_APPEAL_FAILURE = "HP_SUBMIT_CLAIM_APPEAL_FAILURE";

export const HP_GET_IDCARD = "HP_GET_IDCARD";
export const HP_GET_IDCARD_START = "HP_GET_IDCARD_START";
export const HP_GET_IDCARD_SUCCESS = "HP_GET_IDCARD_SUCCESS";
export const HP_GET_IDCARD_FAILURE = "HP_GET_IDCARD_FAILURE";

export const HP_GET_IDCARD_IMAGE = "HP_GET_IDCARD_IMAGE";
export const HP_GET_IDCARD_IMAGE_START = "HP_GET_IDCARD_IMAGE_START";
export const HP_GET_IDCARD_IMAGE_SUCCESS = "HP_GET_IDCARD_IMAGE_SUCCESS";
export const HP_GET_IDCARD_IMAGE_FAILURE = "HP_GET_IDCARD_IMAGE_FAILURE";

export const HP_GET_DOCUMENTS_LIST = "HP_GET_DOCUMENTS_LIST";
export const HP_GET_DOCUMENTS_LIST_START = "HP_GET_DOCUMENTS_LIST_START";
export const HP_GET_DOCUMENTS_LIST_SUCCESS = "HP_GET_DOCUMENTS_LIST_SUCCESS";
export const HP_GET_DOCUMENTS_LIST_FAILURE = "HP_GET_DOCUMENTS_LIST_FAILURE";

export const HP_GET_DOCUMENT_DETAIL = "HP_GET_DOCUMENT_DETAIL";
export const HP_GET_DOCUMENT_DETAIL_START = "HP_GET_DOCUMENT_DETAIL_START";
export const HP_GET_DOCUMENT_DETAIL_SUCCESS = "HP_GET_DOCUMENT_DETAIL_SUCCESS";
export const HP_GET_DOCUMENT_DETAIL_FAILURE = "HP_GET_DOCUMENT_DETAIL_FAILURE";

export const HP_GET_INVOICES_LIST = "HP_GET_INVOICES_LIST";
export const HP_GET_INVOICES_LIST_START = "HP_GET_INVOICES_LIST_START";
export const HP_GET_INVOICES_LIST_SUCCESS = "HP_GET_INVOICES_LIST_SUCCESS";
export const HP_GET_INVOICES_LIST_FAILURE = "HP_GET_INVOICES_LIST_FAILURE";

export const HP_GET_INVOICE_DETAIL = "HP_GET_INVOICE_DETAIL";
export const HP_GET_INVOICE_DETAIL_START = "HP_GET_INVOICE_DETAIL_START";
export const HP_GET_INVOICE_DETAIL_SUCCESS = "HP_GET_INVOICE_DETAIL_SUCCESS";
export const HP_GET_INVOICE_DETAIL_FAILURE = "HP_GET_INVOICE_DETAIL_FAILURE";

export const HP_GET_INVOICE_ADJUSTMENTS = "HP_GET_INVOICE_ADJUSTMENTS";
export const HP_GET_INVOICE_ADJUSTMENTS_START = "HP_GET_INVOICE_ADJUSTMENTS_START";
export const HP_GET_INVOICE_ADJUSTMENTS_SUCCESS = "HP_GET_INVOICE_ADJUSTMENTS_SUCCESS";
export const HP_GET_INVOICE_ADJUSTMENTS_FAILURE = "HP_GET_INVOICE_ADJUSTMENTS_FAILURE";

export const HP_GET_INVOICE_PDF = "HP_GET_INVOICE_PDF";
export const HP_GET_INVOICE_PDF_START = "HP_GET_INVOICE_PDF_START";
export const HP_GET_INVOICE_PDF_SUCCESS = "HP_GET_INVOICE_PDF_SUCCESS";
export const HP_GET_INVOICE_PDF_FAILURE = "HP_GET_INVOICE_PDF_FAILURE";

export const HP_GET_FORM = "HP_GET_FORM";
export const HP_GET_FORM_START = "HP_GET_FORM_START";
export const HP_GET_FORM_SUCCESS = "HP_GET_FORM_SUCCESS";
export const HP_GET_FORM_FAILURE = "HP_GET_FORM_FAILURE";

export const HP_GET_SUBSCRIPTION = "HP_GET_SUBSCRIPTION";
export const HP_GET_SUBSCRIPTION_START = "HP_GET_SUBSCRIPTION_START";
export const HP_GET_SUBSCRIPTION_SUCCESS = "HP_GET_SUBSCRIPTION_SUCCESS";
export const HP_GET_SUBSCRIPTION_FAILURE = "HP_GET_SUBSCRIPTION_FAILURE";

export const HP_GET_MEMBERS_LIST = "HP_GET_MEMBERS_LIST";
export const HP_GET_MEMBERS_LIST_START = "HP_GET_MEMBERS_LIST_START";
export const HP_GET_MEMBERS_LIST_SUCCESS = "HP_GET_MEMBERS_LIST_SUCCESS";
export const HP_GET_MEMBERS_LIST_FAILURE = "HP_GET_MEMBERS_LIST_FAILURE";

export const HP_GET_BENEFIT_PLAN_DETAIL = "HP_GET_BENEFIT_PLAN_DETAIL";
export const HP_GET_BENEFIT_PLAN_DETAIL_START = "HP_GET_BENEFIT_PLAN_DETAIL_START";
export const HP_GET_BENEFIT_PLAN_DETAIL_SUCCESS = "HP_GET_BENEFIT_PLAN_DETAIL_SUCCESS";
export const HP_GET_BENEFIT_PLAN_DETAIL_FAILURE = "HP_GET_BENEFIT_PLAN_DETAIL_FAILURE";

export const HP_GET_AA_BENEFIT_PLAN_DETAIL = "HP_GET_AA_BENEFIT_PLAN_DETAIL";
export const HP_GET_AA_BENEFIT_PLAN_DETAIL_START = "HP_GET_AA_BENEFIT_PLAN_DETAIL_START";
export const HP_GET_AA_BENEFIT_PLAN_DETAIL_SUCCESS = "HP_GET_AA_BENEFIT_PLAN_DETAIL_SUCCESS";
export const HP_GET_AA_BENEFIT_PLAN_DETAIL_FAILURE = "HP_GET_AA_BENEFIT_PLAN_DETAIL_FAILURE";

export const HP_UPDATE_MEMBER_ADDRESS = "HP_UPDATE_MEMBER_ADDRESS";
export const HP_UPDATE_MEMBER_ADDRESS_START = "HP_UPDATE_MEMBER_ADDRESS_START";
export const HP_UPDATE_MEMBER_ADDRESS_SUCCESS = "HP_UPDATE_MEMBER_ADDRESS_SUCCESS";
export const HP_UPDATE_MEMBER_ADDRESS_FAILURE = "HP_UPDATE_MEMBER_ADDRESSE_FAILURE";

export const HP_GET_CORR_EMAIL_ADDRESS = "HP_GET_CORR_EMAIL_ADDRESS";
export const HP_GET_CORR_EMAIL_ADDRESS_START = "HP_GET_CORR_EMAIL_ADDRESS_START";
export const HP_GET_CORR_EMAIL_ADDRESS_SUCCESS = "HP_GET_CORR_EMAIL_ADDRESS_SUCCESS";
export const HP_GET_CORR_EMAIL_ADDRESS_FAILURE = "HP_GET_CORR_EMAIL_ADDRESS_FAILURE";


export const HP_GET_PROFILE = "HP_GET_PROFILE";
export const HP_GET_PROFILE_START = "HP_GET_PROFILE_START";
export const HP_GET_PROFILE_SUCCESS = "HP_GET_PROFILE_SUCCESS";
export const HP_GET_PROFILE_FAILURE = "HP_GET_PROFILE_FAILURE";

export const HP_GET_EOB_DOCUMENT = "HP_GET_EOB_DOCUMENT";
export const HP_GET_EOB_DOCUMENT_START = "HP_GET_EOB_DOCUMENT_START";
export const HP_GET_EOB_DOCUMENT_SUCCESS = "HP_GET_EOB_DOCUMENT_SUCCESS";
export const HP_GET_EOB_DOCUMENT_FAILURE = "HP_GET_EOB_DOCUMENT_FAILURE";

export const HP_GET_SERVICE_CATEGORIES = "HP_GET_SERVICE_CATEGORIES";
export const HP_GET_SERVICE_CATEGORIES_START = "HP_GET_SERVICE_CATEGORIES_START";
export const HP_GET_SERVICE_CATEGORIES_SUCCESS = "HP_GET_SERVICE_CATEGORIES_SUCCESS";
export const HP_GET_SERVICE_CATEGORIES_FAILURE = "HP_GET_SERVICE_CATEGORIES_FAILURE";

export const HP_GET_IS_MEMBER_DPC = "HP_GET_IS_MEMBER_DPC";
export const HP_GET_IS_MEMBER_DPC_START = "HP_GET_IS_MEMBER_DPC_START";
export const HP_GET_IS_MEMBER_DPC_SUCCESS = "HP_GET_IS_MEMBER_DPC_SUCCESS";
export const HP_GET_IS_MEMBER_DPC_FAILURE = "HP_GET_IS_MEMBER_DPC_FAILURE";

export const HP_GET_SUPPORT_MESSAGES = "HP_GET_SUPPORT_MESSAGES";
export const HP_GET_SUPPORT_MESSAGES_START = "HP_GET_SUPPORT_MESSAGES_START";
export const HP_GET_SUPPORT_MESSAGES_SUCCESS = "HP_GET_SUPPORT_MESSAGES_SUCCESS";
export const HP_GET_SUPPORT_MESSAGES_FAILURE = "HP_GET_SUPPORT_MESSAGES_FAILURE";

export const HP_GET_ISSUE_ATTACHMENT_OPTIONS = "HP_GET_ISSUE_ATTACHMENT_OPTIONS";
export const HP_GET_ISSUE_ATTACHMENT_OPTIONS_START = "HP_GET_ISSUE_ATTACHMENT_OPTIONS_START";
export const HP_GET_ISSUE_ATTACHMENT_OPTIONS_SUCCESS = "HP_GET_ISSUE_ATTACHMENT_OPTIONS_SUCCESS";
export const HP_GET_ISSUE_ATTACHMENT_OPTIONS_FAILURE = "HP_GET_ISSUE_ATTACHMENT_OPTIONS_FAILURE";

export const HP_SUBMIT_SERVICE_REQUEST = "HP_SUBMIT_SERVICE_REQUEST";
export const HP_SUBMIT_SERVICE_REQUEST_START = "HP_SUBMIT_SERVICE_REQUEST_START";
export const HP_SUBMIT_SERVICE_REQUEST_SUCCESS = "HP_SUBMIT_SERVICE_REQUEST_SUCCESS";
export const HP_SUBMIT_SERVICE_REQUEST_FAILURE = "HP_SUBMIT_SERVICE_REQUEST_FAILURE";

export const HP_REQUEST_NEW_IDCARD = "HP_REQUEST_NEW_IDCARD";
export const HP_REQUEST_NEW_IDCARD_START = "HP_REQUEST_NEW_IDCARD_START";
export const HP_REQUEST_NEW_IDCARD_SUCCESS = "HP_REQUEST_NEW_IDCARD_SUCCESS";
export const HP_REQUEST_NEW_IDCARD_FAILURE = "HP_REQUEST_NEW_IDCARD_FAILURE";

export const HP_SEND_CRM_MESSAGE = "HP_SEND_CRM_MESSAGE";
export const HP_SEND_CRM_MESSAGE_START = "HP_SEND_CRM_MESSAGE_START";
export const HP_SEND_CRM_MESSAGE_SUCCESS = "HP_SEND_CRM_MESSAGE_SUCCESS";
export const HP_SEND_CRM_MESSAGE_FAILURE = "HP_SEND_CRM_MESSAGE_FAILURE";

export const HP_CREATE_CRM_TICKET = "HP_CREATE_CRM_TICKET";
export const HP_CREATE_CRM_TICKET_START = "HP_CREATE_CRM_TICKET_START";
export const HP_CREATE_CRM_TICKET_SUCCESS = "HP_CREATE_CRM_TICKET_SUCCESS";
export const HP_CREATE_CRM_TICKET_FAILURE = "HP_CREATE_CRM_TICKET_FAILURE";

export const HP_GET_DENTAL_INVOICE_DETAIL = "HP_GET_DENTAL_INVOICE_DETAIL";
export const HP_GET_DENTAL_INVOICE_DETAIL_START = "HP_GET_DENTAL_INVOICE_DETAIL_START";
export const HP_GET_DENTAL_INVOICE_DETAIL_SUCCESS = "HP_GET_DENTAL_INVOICE_DETAIL_SUCCESS";
export const HP_GET_DENTAL_INVOICE_DETAIL_FAILURE = "HP_GET_DENTAL_INVOICE_DETAIL_FAILURE";

export const HP_GET_GROUPED_PROCEDURES_START = "HP_GET_GROUPED_PROCEDURES_START";
export const HP_GET_GROUPED_PROCEDURES_SUCCESS = "HP_GET_GROUPED_PROCEDURES_SUCCESS";
export const HP_GET_GROUPED_PROCEDURES_FAILURE = "HP_GET_GROUPED_PROCEDURES_FAILURE";

export const HP_GET_GROUPED_PROCEDURES_BY_CPT_START = "HP_GET_GROUPED_PROCEDURES_BY_CPT_START";
export const HP_GET_GROUPED_PROCEDURES_BY_CPT_SUCCESS = "HP_GET_GROUPED_PROCEDURES_BY_CPT_SUCCESS";
export const HP_GET_GROUPED_PROCEDURES_BY_CPT_FAILURE = "HP_GET_GROUPED_PROCEDURES_BY_CPT_FAILURE";

export const HP_GET_PROCEDURE_COST_START = "HP_GET_PROCEDURE_COST_START";
export const HP_GET_PROCEDURE_COST_SUCCESS = "HP_GET_PROCEDURE_COST_SUCCESS";
export const HP_GET_PROCEDURE_COST_FAILURE = "HP_GET_PROCEDURE_COST_FAILURE";
export const HP_GET_PROCEDURE_COST_CLEAR = "HP_GET_PROCEDURE_COST_CLEAR";

export const HP_GET_TAX_DOCUMENT_LIST_START = "HP_GET_TAX_DOCUMENT_LIST_START";
export const HP_GET_TAX_DOCUMENT_LIST_SUCCESS = "HP_GET_TAX_DOCUMENT_LIST_SUCCESS";
export const HP_GET_TAX_DOCUMENT_LIST_FAILURE = "HP_GET_TAX_DOCUMENT_LIST_FAILURE";

export const HP_GET_TAX_DOCUMENT_URL_START = "HP_GET_TAX_DOCUMENT_URL_START";
export const HP_GET_TAX_DOCUMENT_URL_SUCCESS = "HP_GET_TAX_DOCUMENT_URL_SUCCESS";
export const HP_GET_TAX_DOCUMENT_URL_FAILURE = "HP_GET_TAX_DOCUMENT_URL_FAILURE";

export const GET_APP_UPDATE = "GET_APP_UPDATE";
export const GOT_APP_UPDATE = "GOT_APP_UPDATE";
export const HIDE_NORMAL_APP_UPDATE = "HIDE_NORMAL_APP_UPDATE";
export const IS_HEADER_SHRINKED = "IS_HEADER_SHRINKED";

export const GRAPHIC_BANNER_UPDATE = "GRAPHIC_BANNER_UPDATE";

export const SET_HIDE_AUTO_HP_LINKMODAL = "SET_HIDE_AUTO_HP_LINKMODAL";

export const LOAD_HEALTHPLAN_DATA_START = "LOAD_HEALTHPLAN_DATA_START";
export const LOAD_HEALTHPLAN_DATA_SUCCESS = "LOAD_HEALTHPLAN_DATA_SUCCESS";
export const LOAD_HEALTHPLAN_DATA_FAILURE = "LOAD_HEALTHPLAN_DATA_FAILURE";

export const LINK_HEALTHPLAN_ACCOUNT = "LINK_HEALTHPLAN_ACCOUNT";
export const LINK_HEALTHPLAN_ACCOUNT_SUCCESS = "LINK_HEALTHPLAN_ACCOUNT_SUCCESS";
export const LINK_HEALTHPLAN_ACCOUNT_FAILURE = "LINK_HEALTHPLAN_ACCOUNT_FAILURE";
export const LINK_HEALTHPLAN_CLEAR_MESSAGE = "LINK_HEALTHPLAN_CLEAR_MESSAGE";
export const UNLINK_HEALTHPLAN_ACCOUNT = "UNLINK_HEALTHPLAN_ACCOUNT";
export const UNLINK_HEALTHPLAN_ACCOUNT_SUCCESS = "UNLINK_HEALTHPLAN_ACCOUNT_SUCCESS";
export const UNLINK_HEALTHPLAN_ACCOUNT_FAILURE = "UNLINK_HEALTHPLAN_ACCOUNT_FAILURE";
export const UNLINK_HEALTHPLAN_CLEAR_MESSAGE = "UNLINK_HEALTHPLAN_CLEAR_MESSAGE";

export const LINK_AUTO_HP_ACCOUNT_START = "LINK_AUTO_HP_ACCOUNT_START";
export const LINK_AUTO_HP_ACCOUNT_SUCCESS = "LINK_AUTO_HP_ACCOUNT_SUCCESS";
export const LINK_AUTO_HP_ACCOUNT_FAILURE = "LINK_AUTO_HP_ACCOUNT_FAILURE";
export const LINK_AUTO_HP_ACCOUNT_CLEAR_MESSAGE = "LINK_AUTO_HP_ACCOUNT_CLEAR_MESSAGE";

export const LINK_AA_ACCOUNT_START = "LINK_AA_ACCOUNT_START";
export const LINK_AA_ACCOUNT_SUCCESS = "LINK_AA_ACCOUNT_SUCCESS";
export const LINK_AA_ACCOUNT_FAILURE = "LINK_AA_ACCOUNT_FAILURE";
export const LINK_AA_ACCOUNT_CLEAR_MESSAGE = "LINK_AA_ACCOUNT_CLEAR_MESSAGE";
export const LINK_AA_ACCOUNT_ERROR_COUNT = "LINK_AA_ACCOUNT_ERROR_COUNT";
export const LINK_AA_ACCOUNT_UPDATE_TOKEN_SUCCESS = "LINK_AA_ACCOUNT_UPDATE_TOKEN_SUCCESS";

export const UNLINK_AA_ACCOUNT_START = "UNLINK_AA_ACCOUNT_START";
export const UNLINK_AA_ACCOUNT_SUCCESS = "UNLINK_AA_ACCOUNT_SUCCESS";
export const UNLINK_AA_ACCOUNT_FAILURE = "UNLINK_AA_ACCOUNT_FAILURE";
export const UNLINK_AA_ACCOUNT_CLEAR_MESSAGE = "UNLINK_AA_ACCOUNT_CLEAR_MESSAGE";
export const UNLINK_AA_ACCOUNT_UPDATE_TOKEN_SUCCESS = "UNLINK_AA_ACCOUNT_UPDATE_TOKEN_SUCCESS";

export const LINK_FIRST_CARE_ACCOUNT = "LINK_FIRST_CARE_ACCOUNT";
export const LINK_FIRST_CARE_ACCOUNT_SUCCESS = "LINK_FIRST_CARE_ACCOUNT_SUCCESS";
export const LINK_FIRST_CARE_ACCOUNT_FAILURE = "LINK_FIRST_CARE_ACCOUNT_FAILURE";
export const LINK_FIRST_CARE_ACCOUNT_CLEAR = "LINK_FIRST_CARE_ACCOUNT_CLEAR";

export const UNLINK_FIRST_CARE_ACCOUNT = "UNLINK_FIRST_CARE_ACCOUNT";
export const UNLINK_FIRST_CARE_ACCOUNT_SUCCESS = "UNLINK_FIRST_CARE_ACCOUNT_SUCCESS";
export const UNLINK_FIRST_CARE_ACCOUNT_FAILURE = "UNLINK_FIRST_CARE_ACCOUNT_FAILURE";
export const UNLINK_FIRST_CARE_ACCOUNT_CLEAR = "UNLINK_FIRST_CARE_ACCOUNT_CLEAR";

export const LINK_DART_ACCOUNT = "LINK_DART_ACCOUNT";
export const LINK_DART_ACCOUNT_SUCCESS = "LINK_DART_ACCOUNT_SUCCESS";
export const LINK_DART_ACCOUNT_FAILURE = "LINK_DART_ACCOUNT_FAILURE";
export const LINK_DART_ACCOUNT_CLEAR = "LINK_DART_ACCOUNT_CLEAR";

export const UNLINK_DART_ACCOUNT = "UNLINK_DART_ACCOUNT";
export const UNLINK_DART_ACCOUNT_SUCCESS = "UNLINK_DART_ACCOUNT_SUCCESS";
export const UNLINK_DART_ACCOUNT_FAILURE = "UNLINK_DART_ACCOUNT_FAILURE";
export const UNLINK_DART_ACCOUNT_CLEAR = "UNLINK_DART_ACCOUNT_CLEAR";

export const LINK_WACO_ACCOUNT = "LINK_WACO_ACCOUNT";
export const LINK_WACO_ACCOUNT_SUCCESS = "LINK_WACO_ACCOUNT_SUCCESS";
export const LINK_WACO_ACCOUNT_FAILURE = "LINK_WACO_ACCOUNT_FAILURE";
export const LINK_WACO_ACCOUNT_CLEAR = "LINK_WACO_ACCOUNT_CLEAR";

export const UNLINK_WACO_ACCOUNT = "UNLINK_WACO_ACCOUNT";
export const UNLINK_WACO_ACCOUNT_SUCCESS = "UNLINK_WACO_ACCOUNT_SUCCESS";
export const UNLINK_WACO_ACCOUNT_FAILURE = "UNLINK_WACO_ACCOUNT_FAILURE";
export const UNLINK_WACO_ACCOUNT_CLEAR = "UNLINK_WACO_ACCOUNT_CLEAR";

export const COOKIE_BSWPROXY_START = "COOKIE_BSWPROXY_START";
export const COOKIE_BSWPROXY_SUCCESS = "COOKIE_BSWPROXY_SUCCESS";

export const ZIPNOSIS_EVISIT_URL = "ZIPNOSIS_EVISIT_URL";
export const ZIPNOSIS_EVISIT_URL_SUCCESS = "ZIPNOSIS_EVISIT_URL_SUCCESS";
export const ZIPNOSIS_EVISIT_URL_FAILURE = "ZIPNOSIS_EVISIT_URL_FAILURE";
export const ZIPNOSIS_EVISIT_CLEAR = "ZIPNOSIS_EVISIT_CLEAR";

export const UPDATE_MENU = "UPDATE_MENU";
export const HIDE_BANNER_ON_CRASH = "HIDE_BANNER_ON_CRASH";

export const GET_EPIC_LETTERS = "GET_EPIC_LETTERS";
export const GET_EPIC_LETTERS_SUCCESS = "GET_EPIC_LETTERS_SUCCESS";
export const GET_EPIC_LETTERS_FAILURE = "GET_EPIC_LETTERS_FAILURE";

export const PROXY_RELATIONSHIP_TYPES = "PROXY_RELATIONSHIP_TYPES";
export const PROXY_RELATIONSHIP_TYPES_PENDING = "PROXY_RELATIONSHIP_TYPES_PENDING";
export const PROXY_RELATIONSHIP_TYPES_SUCCESS = "PROXY_RELATIONSHIP_TYPES_SUCCESS";
export const PROXY_RELATIONSHIP_TYPES_FAILURE = "PROXY_RELATIONSHIP_TYPES_FAILURE";

export const PROXY_RELATIONSHIP_SET = "PROXY_RELATIONSHIP_SET";
export const PROXY_RELATIONSHIP_SET_PENDING = "PROXY_RELATIONSHIP_SET_PENDING";
export const PROXY_RELATIONSHIP_SET_SUCCESS = "PROXY_RELATIONSHIP_SET_SUCCESS";
export const PROXY_RELATIONSHIP_SET_FAILURE = "PROXY_RELATIONSHIP_SET_FAILURE";

export const PROXY_RELATIONSHIP_ACCEPT = "PROXY_RELATIONSHIP_ACCEPT";
export const PROXY_RELATIONSHIP_ACCEPT_PENDING = "PROXY_RELATIONSHIP_ACCEPT_PENDING";
export const PROXY_RELATIONSHIP_ACCEPT_SUCCESS = "PROXY_RELATIONSHIP_ACCEPT_SUCCESS";
export const PROXY_RELATIONSHIP_ACCEPT_FAILURE = "PROXY_RELATIONSHIP_ACCEPT_FAILURE";

export const PROXY_RELATIONSHIP_GRANT = "PROXY_RELATIONSHIP_GRANT";
export const PROXY_RELATIONSHIP_GRANT_PENDING = "PROXY_RELATIONSHIP_GRANT_PENDING";
export const PROXY_RELATIONSHIP_GRANT_SUCCESS = "PROXY_RELATIONSHIP_GRANT_SUCCESS";
export const PROXY_RELATIONSHIP_GRANT_FAILURE = "PROXY_RELATIONSHIP_GRANT_FAILURE";

export const PROXY_RELATIONSHIP_DELETE = "PROXY_RELATIONSHIP_DELETE";
export const PROXY_RELATIONSHIP_DELETE_PENDING = "PROXY_RELATIONSHIP_DELETE_PENDING";
export const PROXY_RELATIONSHIP_DELETE_SUCCESS = "PROXY_RELATIONSHIP_DELETE_SUCCESS";
export const PROXY_RELATIONSHIP_DELETE_FAILURE = "PROXY_RELATIONSHIP_DELETE_FAILURE";

export const REFRESH_PROXY_LIST = "REFRESH_PROXY_LIST";

export const UPDATE_INSURANCE_PREFERENCE = "UPDATE_INSURANCE_PREFERENCE";
export const SHOW_INSURANCE_FORM = "SHOW_INSURANCE_FORM";

//BEGIN Onboarding Flow V2 Perferences
//action that determines if the FamilyMembers screen should be shown during Onboarding flow
export const SHOW_FAMILYMEMBERS_SCREEN = "SHOW_FAMILYMEMBERS_SCREEN";
export const UPDATE_FAMILYMEMBERS_SCREEN_PREFERENCE = "UPDATE_FAMILYMEMBERS_PREFERENCE";
export const SHOW_NOTIFICATIONS_SCREEN = "SHOW_NOTIFICATIONS_SCREEN";
export const UPDATE_NOTIFICATIONS_SCREEN_PREFERENCE = "UPDATE_NOTIFICATIONS_SCREEN_PREFERENCE";
export const SHOW_SCHEDULE_CARE_TOOLTIP = "SHOW_SCHEDULE_CARE_TOOLTIP";
export const UPDATE_SCHEDULE_CARE_TOOLTIP_PREFERENCE = "UPDATE_SCHEDULE_CARE_TOOLTIP_PREFERENCE";
export const HAS_COMPLETED_ONBOARDING = "HAS_COMPLETED_ONBOARDING";
export const SET_USE_ONBOARDING_LAYOUT = 'SET_USE_ONBOARDING_LAYOUT'
export const INITIALIZE_ONBOARDING_PREFERENCES = 'INITIALIZE_ONBOARDING_PREFERENCES'
//END Onboarding V2 Preferences

export const UPDATE_CARE_COACH_MODAL_PREFERENCE = "UPDATE_CARE_COACH_MODAL_PREFERENCE";

export const SHOW_AUTOLINK_MYCHART = "SHOW_AUTOLINK_MYCHART";
export const UPDATE_AUTOLINK_MYCHART_PREFERENCE = "UPDATE_AUTOLINK_MYCHART_PREFERENCE";

export const AUTOLINK_MYCHART = "AUTOLINK_MYCHART";
export const AUTOLINK_MYCHART_SUCCESS = "AUTOLINK_MYCHART_SUCCESS";
export const AUTOLINK_MYCHART_FAILURE = "AUTOLINK_MYCHART_FAILURE";
export const AUTOLINK_MYCHART_ERROR_COUNT = "AUTOLINK_MYCHART_ERROR_COUNT";
export const AUTOLINK_MYCHART_UPDATE_TOKEN_SUCCESS = "AUTOLINK_MYCHART_UPDATE_TOKEN_SUCCESS";
export const AUTOLINK_MYCHART_CLEAR_MESSAGE = "AUTOLINK_MYCHART_CLEAR_MESSAGE";

export const INITIATE_PROXY_RX_REQUEST = "INITIATE_PROXY_RX_REQUEST";
export const INITIATE_PROXY_RX_REQUEST_FAILURE = "INITIATE_PROXY_RX_REQUEST_FAILURE";
export const INITIATE_PROXY_EPIC_REQUEST = "INITIATE_PROXY_EPIC_REQUEST";
export const REQUEST_PROXY_INFO = "REQUEST_PROXY_INFO";
export const REQUEST_PROXY_ACCESS_LIST = "REQUEST_PROXY_ACCESS_LIST";
export const REQUEST_PROXY_FAMILY_MEMBERS_LIST = "REQUEST_PROXY_FAMILY_MEMBERS_LIST";
export const REQUEST_PROXY_CHANGE_STATUS = "REQUEST_PROXY_CHANGE_STATUS";
export const VERIFY_REQUESTOR_DOB = "VERIFY_REQUESTOR_DOB";
export const VERIFY_REQUESTOR_DOB_FAILURE = "VERIFY_REQUESTOR_DOB_FAILURE";
export const REQUEST_PROXY_RESEND = "REQUEST_PROXY_RESEND";
export const REQUEST_PROXY_CANCEL = "REQUEST_PROXY_CANCEL";
export const SET_PROXY_MESSAGE = "SET_PROXY_MESSAGE";
export const CLEAR_PROXY_MESSAGE = "CLEAR_PROXY_MESSAGE";
export const INITIATE_PROXY_EPIC_REQUEST_FAILURE = "INITIATE_PROXY_EPIC_REQUEST_FAILURE";
export const PROXY_TERMS_AND_CONDITIONS = "PROXY_TERMS_AND_CONDITIONS";
export const PROXY_TERMS_AND_CONDITIONS_SUCCESS = "PROXY_TERMS_AND_CONDITIONS_SUCCESS";
export const PROXY_TERMS_AND_CONDITIONS_FAILURE = "PROXY_TERMS_AND_CONDITIONS_FAILURE";
export const ACCEPT_PROXY_TERMS_AND_CONDITIONS = "ACCEPT_PROXY_TERMS_AND_CONDITIONS";
export const ACCEPT_PROXY_TERMS_AND_CONDITIONS_SUCCESS = "ACCEPT_PROXY_TERMS_AND_CONDITIONS_SUCCESS";
export const ACCEPT_PROXY_TERMS_AND_CONDITIONS_FAILURE = "ACCEPT_PROXY_TERMS_AND_CONDITIONS_FAILURE";
export const CLEAR_REQUEST_PROXY_CHANGE_STATUS_ERROR = "CLEAR_REQUEST_PROXY_CHANGE_STATUS_ERROR";

export const SET_EMAIL_APPROVED_PROXY_REQUEST = "SET_EMAIL_APPROVED_PROXY_REQUEST";
export const CLEAR_EMAIL_PROXY_MESSAGE = "CLEAR_EMAIL_PROXY_MESSAGE ";

export const CARE_COACH_NOTIFICATION_PREFERENCE_SAVE = "CARE_COACH_NOTIFICATION_PREFERENCE_SAVE";
export const GET_USER_NOTIFICATION_PREFERENCE = "GET_USER_NOTIFICATION_PREFERENCE";
export const GENERAL_NOTIFICATION_PREFERENCE_SAVE = "GENERAL_NOTIFICATION_PREFERENCE_SAVE";

export const UPDATE_ADD_DEPENDENT_PROXY_PREFERENCE = "UPDATE_ADD_DEPENDENT_PROXY_PREFERENCE";
export const SHOW_ADD_DEPENDENT_PROXY_FORM = "SHOW_ADD_DEPENDENT_PROXY_FORM";

export const LOAD_BFF_DASHBOARD_START = "LOAD_BFF_DASHBOARD_START";
export const LOAD_BFF_DASHBOARD_SUCCESS = "LOAD_BFF_DASHBOARD_SUCCESS";
export const LOAD_BFF_DASHBOARD_PENDING = "LOAD_BFF_DASHBOARD_PENDING";
export const LOAD_BFF_DASHBOARD_FAILURE = "LOAD_BFF_DASHBOARD_FAILURE";

export const LOAD_CURRENT_MANAGERS_PENDING = "LOAD_CURRENT_MANAGERS_PENDING";
export const LOAD_CURRENT_MANAGERS_SUCCESS = "LOAD_CURRENT_MANAGERS_SUCCESS";
export const LOAD_CURRENT_MANAGERS_FAILURE = "LOAD_CURRENT_MANAGERS_FAILURE";

export const GET_VIDEO_VISIT_CONDITIONS = "GET_VIDEO_VISIT_CONDITIONS";
export const GET_VIDEO_VISIT_CONDITIONS_PENDING = "GET_VIDEO_VISIT_CONDITIONS_PENDING";
export const GET_VIDEO_VISIT_CONDITIONS_SUCCESS = "GET_VIDEO_VISIT_CONDITIONS_SUCCESS";
export const GET_VIDEO_VISIT_CONDITIONS_FAILURE = "GET_VIDEO_VISIT_CONDITIONS_FAILURE";

export const GET_VIDEO_VISIT_TIME_SLOTS = "GET_VIDEO_VISIT_TIME_SLOTS";
export const GET_VIDEO_VISIT_TIME_SLOTS_PENDING = "GET_VIDEO_VISIT_TIME_SLOTS_PENDING";
export const GET_VIDEO_VISIT_TIME_SLOTS_SUCCESS = "GET_VIDEO_VISIT_TIME_SLOTS_SUCCESS";
export const GET_VIDEO_VISIT_TIME_SLOTS_FAILURE = "GET_VIDEO_VISIT_TIME_SLOTS_FAILURE";

export const SCHEDULE_VIDEO_VISIT_REQUEST = "SCHEDULE_VIDEO_VISIT_REQUEST";
export const SCHEDULE_VIDEO_VISIT_REQUEST_PENDING = "SCHEDULE_VIDEO_VISIT_REQUEST_PENDING";
export const SCHEDULE_VIDEO_VISIT_REQUEST_SUCCESS = "SCHEDULE_VIDEO_VISIT_REQUEST_SUCCESS";
export const SCHEDULE_VIDEO_VISIT_REQUEST_FAILURE = "SCHEDULE_VIDEO_VISIT_REQUEST_FAILURE";

export const GET_VIDEO_VISIT_TERMS = "GET_VIDEO_VISIT_TERMS";
export const GET_VIDEO_VISIT_TERMS_PENDING = "GET_VIDEO_VISIT_TERMS_PENDING";
export const GET_VIDEO_VISIT_TERMS_SUCCESS = "GET_VIDEO_VISIT_TERMS_SUCCESS";
export const GET_VIDEO_VISIT_TERMS_FAILURE = "GET_VIDEO_VISIT_TERMS_FAILURE";

export const GET_VIDEO_VISIT_LINK = "GET_VIDEO_VISIT_LINK";
export const GET_VIDEO_VISIT_LINK_SUCCESS = "GET_VIDEO_VISIT_LINK_SUCCESS";
export const GET_VIDEO_VISIT_LINK_FAILURE = "GET_VIDEO_VISIT_LINK_FAILURE";
export const GET_VIDEO_VISIT_LINK_RESET = "GET_VIDEO_VISIT_LINK_RESET";

export const ACCEPT_VIDEO_VISIT_CONDITIONS = "ACCEPT_VIDEO_VISIT_CONDITIONS";
export const ACCEPT_VIDEO_VISIT_CONDITIONS_PENDING = "ACCEPT_VIDEO_VISIT_CONDITIONS_PENDING";
export const ACCEPT_VIDEO_VISIT_CONDITIONS_SUCCESS = "ACCEPT_VIDEO_VISIT_CONDITIONS_SUCCESS";
export const ACCEPT_VIDEO_VISIT_CONDITIONS_FAILURE = "ACCEPT_VIDEO_VISIT_CONDITIONS_FAILURE";

export const SHOW_VIDEO_VISIT_TOOLTIP = "SHOW_VIDEO_VISIT_TOOLTIP";
export const UPDATE_VIDEO_VISIT_TOOLTIP_PREFERENCE = "UPDATE_VIDEO_VISIT_TOOLTIP_PREFERENCE";
export const GET_SPECIFIC_XEALTH_MESSAGE = "GET_SPECIFIC_XEALTH_MESSAGE";
export const GET_SPECIFIC_XEALTH_MESSAGE_PENDING = "GET_SPECIFIC_XEALTH_MESSAGE_PENDING";
export const GET_SPECIFIC_XEALTH_MESSAGE_FAILURE = "GET_SPECIFIC_XEALTH_MESSAGE_FAILURE";
export const GET_SPECIFIC_XEALTH_MESSAGE_SUCCESS = "GET_SPECIFIC_XEALTH_MESSAGE_SUCCESS";


export const AMBULATORY_VIDEO_VISIT_SURVEY_REQUEST = "AMBULATORY_VIDEO_VISIT_SURVEY_REQUEST";
export const AMBULATORY_VIDEO_VISIT_SURVEY_REQUEST_PENDING = "AMBULATORY_VIDEO_VISIT_SURVEY_REQUEST_PENDING";
export const AMBULATORY_VIDEO_VISIT_SURVEY_REQUEST_SUCCESS = "AMBULATORY_VIDEO_VISIT_SURVEY_REQUEST_SUCCESS";
export const AMBULATORY_VIDEO_VISIT_SURVEY_REQUEST_FAILURE = "AMBULATORY_VIDEO_VISIT_SURVEY_REQUEST_FAILURE";

export const GET_ECHECKIN_STATUS = "GET_ECHECKIN_STATUS";
export const GET_ECHECKIN_STATUS_PENDING = "GET_ECHECKIN_STATUS_PENDING";
export const GET_ECHECKIN_STATUS_SUCCESS = "GET_ECHECKIN_STATUS_SUCCESS";
export const GET_ECHECKIN_STATUS_FAILURE = "GET_ECHECKIN_STATUS_FAILURE";

export const GET_ROOM_STATUSES_SUCCESS = "GET_ROOM_STATUSES_SUCCESS";
export const GET_ROOM_STATUSES_FAILURE = "GET_ROOM_STATUSES_FAILURE";

export const GET_CONSUMER_JWT = "GET_CONSUMER_JWT";
export const GET_CONSUMER_JWT_PENDING = "GET_CONSUMER_JWT_PENDING";
export const GET_CONSUMER_JWT_SUCCESS = "GET_CONSUMER_JWT_SUCCESS";
export const GET_CONSUMER_JWT_FAILURE = "GET_CONSUMER_JWT_FAILURE";

export const GET_PROVIDER_JWT = "GET_PROVIDER_JWT";
export const GET_PROVIDER_JWT_PENDING = "GET_PROVIDER_JWT_PENDING";
export const GET_PROVIDER_JWT_SUCCESS = "GET_PROVIDER_JWT_SUCCESS";
export const GET_PROVIDER_JWT_FAILURE = "GET_PROVIDER_JWT_FAILURE";

export const HP_USERDATA_SUCCESS = "HP_USERDATA_SUCCESS";
export const HP_AMI_ISUSERPAYER_SUCCESS = "HP_AMI_ISUSERPAYER_SUCCESS";
//export const HP_USERDATA_STORETOKEN = "HP_USERDATA_STORETOKEN"; not needed, using portals token, keeping just incase

export const SAVE_PROXY_REQUESTEE_INFO = "SAVE_PROXY_REQUESTEE_INFO";
export const UPDATE_PROXY_REQUESTEE_INFO = "UPDATE_PROXY_REQUESTEE_INFO";
export const UPDATE_GETCARE_TOOLTIP_PREFERENCE = "UPDATE_GETCARE_TOOLTIP_PREFERENCE";
export const SHOW_GET_CARE_TOOLTIP = "SHOW_GET_CARE_TOOLTIP";

export const SHOW_FAMILY_MANAGEMENT_TOOLTIP = "SHOW_FAMILY_MANAGEMENT_TOOLTIP";
export const UPDATE_FAMILY_MANAGEMENT_TOOLTIP_PREFERENCE = "UPDATE_FAMILY_MANAGEMENT_TOOLTIP_PREFERENCE";
export const SET_HP_PREFIX = "SET_HP_PREFIX";

export const SET_HEALTHPLAN_INFO = "SET_HEALTHPLAN_INFO";
export const SET_HEALTHPLAN_MAINTENANCE_EVENTS = "SET_HEALTHPLAN_MAINTENANCE_EVENTS";

export const INITIATE_PROXY_EPIC_GRANT = "INITIATE_PROXY_EPIC_GRANT";
export const INITIATE_PROXY_EPIC_GRANT_FAILURE = "INITIATE_PROXY_EPIC_GRANT_FAILURE";
export const INITIATE_PROXY_RX_GRANT = "INITIATE_PROXY_RX_GRANT";
export const INITIATE_PROXY_RX_GRANT_FAILURE = "INITIATE_PROXY_RX_GRANT_FAILURE";

export const GET_PROVIDERS_LIST_BY_VISITTYPE = "GET_PROVIDERS_LIST_BY_VISITTYPE";
export const GET_PROVIDERS_LIST_BY_VISITTYPE_SUCCESS = "GET_PROVIDERS_LIST_BY_VISITTYPE_SUCCESS";
export const GET_PROVIDERS_LIST_BY_VISITTYPE_ERROR = "GET_PROVIDERS_LIST_BY_VISITTYPE_ERROR";

export const GET_PROVIDERS_LIST_VISITTYPE = "GET_PROVIDERS_LIST_VISITTYPE";
export const GET_PROVIDERS_LIST_VISITTYPE_SUCCESS = "GET_PROVIDERS_LIST_BY_VISITTYPE_SUCCESS";
export const GET_PROVIDERS_LIST_VISITTYPE_ERROR = "GET_PROVIDERS_LIST_VISITTYPE_ERROR";
export const GET_PROVIDERS_LIST_VISITTYPE_FAILURE = "GET_PROVIDERS_LIST_VISITTYPE_FAILURE";
export const GET_PROVIDERS_LIST_VISITTYPE_PENDING = "GET_PROVIDERS_LIST_VISITTYPE_PENDING";


export const GET_PROVIDER_WITH_EARLIESTSCHEDULE = "GET_PROVIDER_WITH_EARLIESTSCHEDULE";
export const GET_PROVIDER_WITH_EARLIESTSCHEDULE_SUCCESS = "GET_PROVIDER_WITH_EARLIESTSCHEDULE_SUCCESS";
export const GET_PROVIDER_WITH_EARLIESTSCHEDULE_ERROR = "GET_PROVIDER_WITH_EARLIESTSCHEDULE_ERROR";

//export const SHOW_DCJ_SELF_ENROLL_TOOLTIP = "SHOW_DCJ_SELF_ENROLL_TOOLTIP";
//export const UPDATE_DCJ_SELF_ENROLL_TOOLTIP_PREFERENCE = "UPDATE_DCJ_SELF_ENROLL_TOOLTIP_PREFERENCE";
//export const CARECOACH_JOURNEY_PREFERENCE = "CARECOACH_JOURNEY_PREFERENCE";
//export const UPDATE_CARECOACH_JOURNEY_PREFERENCE = "UPDATE_CARECOACH_JOURNEY_PREFERENCE";
//export const DCJ_SELF_ORDER = "DCJ_SELF_ORDER";
//export const DCJ_SELF_ORDER_PENDING = "DCJ_SELF_ORDER_PENDING";
//export const DCJ_SELF_ORDER_SUCCESS = "DCJ_SELF_ORDER_SUCCESS";
//export const DCJ_SELF_ORDER_FAILURE = "DCJ_SELF_ORDER_FAILURE";

//export const DCJ_SELF_ORDER_OPTOUT = "DCJ_SELF_ORDER_OPTOUT";
//export const DCJ_SELF_ORDER_OPTOUT_PENDING = "DCJ_SELF_ORDER_OPTOUT_PENDING";
//export const DCJ_SELF_ORDER_OPTOUT_SUCCESS = "DCJ_SELF_ORDER_OPTOUT_SUCCESS";
//export const DCJ_SELF_ORDER_OPTOUT_FAILURE = "DCJ_SELF_ORDER_OPTOUT_FAILURE";
//export const UPDATE_DCJ_SELF_ORDER_OPTOUT_CONFIRM = "UPDATE_DCJ_SELF_ORDER_OPTOUT_CONFIRM";

export const PROXY_STATUS = "PROXY_STATUS";
export const PROXY_STATUS_FAILURE = "PROXY_STATUS_FAILURE";

export const PROXY_DETAILS = "PROXY_DETAILS";

/*START PRICING ESTIMATES BENEFIT */
export const PRICING_USERQUOTE_APPOINTMENTS_LOADING = "PRICING_USERQUOTE_APPOINTMENTS_LOADING";
export const PRICING_USERQUOTE_APPOINTMENTS_ERROR = "PRICING_USERQUOTE_APPOINTMENTS_ERROR";
export const PRICING_USER_PROXY_SELECTED_INITIAL_STATE = "PRICING_USER_PROXY_SELECTED_INITIAL_STATE";
export const PRICING_USERSQUOTE_QUOTE_CLEAR = "PRICING_USERSQUOTE_QUOTE_CLEAR";
export const PRICING_USERSQUOTE_QUOTE_CLEAR_SUCCESS = "PRICING_USERSQUOTE_QUOTE_CLEAR_SUCCESS";
export const PRICING_USERSQUOTE_BENEFITDETAILS = "PRICING_USERSQUOTE_BENEFITDETAILS";
export const PRICING_USERSQUOTE_APPOINTMENTS = "PRICING_USERSQUOTE_APPOINTMENTS";
export const PRICING_USERSQUOTE_APPOINTMENTS_SUCCESS = "PRICING_USERSQUOTE_APPOINTMENTS_SUCCESS";
export const PRICING_USERSQUOTE_BENEFITDETAILS_SUCCESS = "PRICING_USERSQUOTE_BENEFITDETAILS_SUCCESS";
export const PRICING_USER_PROXY_SUCCESS = "PRICING_USER_PROXY_SUCCESS";
export const PRICING_USERQUOTE_PROXYLIST_SUCCESS = "PRICING_USERQUOTE_PROXYLIST_SUCCESS";
export const PRICING_USERSQUOTE_ESTIMATE_PDF = "PRICING_USERSQUOTE_ESTIMATE_PDF";
export const PRICING_USERSQUOTE_ESTIMATE_PDF_SUCCESS = "PRICING_USERSQUOTE_ESTIMATE_PDF_SUCCESS";
export const ESTIMATE_DETAILS_TILE_MESSAGE_DETAILS = "ESTIMATE_DETAILS_TILE_MESSAGE_DETAILS";
export const ESTIMATE_DETAILS_TILE_MESSAGE_DETAILS_SUCCESS = "ESTIMATE_DETAILS_TILE_MESSAGE_DETAILS_SUCCESS";
export const ESTIMATE_DETAILS_SCROLL_TO_BOTTOM = "ESTIMATE_DETAILS_SCROLL_TO_BOTTOM";
export const ESTIMATE_DETAILS_SCROLL_TO_BOTTOM_SUCCESS = "ESTIMATE_DETAILS_SCROLL_TO_BOTTOM_SUCCESS";
/*END*/

//export const DCJ_INBOX_GET_JOURNEYS = "DCJ_INBOX_GET_JOURNEYS";
//export const DCJ_INBOX_GET_JOURNEYS_PENDING = "DCJ_INBOX_GET_JOURNEYS_PENDING";
//export const DCJ_INBOX_GET_JOURNEYS_SUCCESS = "DCJ_INBOX_GET_JOURNEYS_SUCCESS";
//export const DCJ_INBOX_GET_JOURNEYS_FAILURE = "DCJ_INBOX_GET_JOURNEYS_FAILURE";
//export const DCJ_INBOX_SET_SELECTED_JOURNEY = "DCJ_INBOX_SET_SELECTED_JOURNEY";
//export const DCJ_INBOX_GET_CONVERSATIONS = "DCJ_INBOX_GET_CONVERSATIONS";
//export const DCJ_INBOX_GET_CONVERSATIONS_PENDING = "DCJ_INBOX_GET_CONVERSATIONS_PENDING";
//export const DCJ_INBOX_GET_CONVERSATIONS_SUCCESS = "DCJ_INBOX_GET_CONVERSATIONS_SUCCESS";
//export const DCJ_INBOX_GET_CONVERSATIONS_FAILURE = "DCJ_INBOX_GET_CONVERSATIONS_FAILURE";
//export const DCJ_INBOX_GET_MESSAGES = "DCJ_INBOX_GET_MESSAGES";
//export const DCJ_INBOX_GET_MESSAGES_PENDING = "DCJ_INBOX_GET_MESSAGES_PENDING";
//export const DCJ_INBOX_GET_MESSAGES_SUCCESS = "DCJ_INBOX_GET_MESSAGES_SUCCESS";
//export const DCJ_INBOX_GET_MESSAGES_FAILURE = "DCJ_INBOX_GET_MESSAGES_FAILURE";
//export const DCJ_INBOX_RESET = "DCJ_INBOX_RESET";

//export const DCJ_INBOX_MARK_CONVERSATION_READ = "DCJ_INBOX_MARK_CONVERSATION_READ";
//export const DCJ_INBOX_MARK_CONVERSATION_READ_PENDING = "DCJ_INBOX_MARK_CONVERSATION_READ_PENDING";
//export const DCJ_INBOX_MARK_CONVERSATION_READ_SUCCESS = "DCJ_INBOX_MARK_CONVERSATION_READ_SUCCESS";
//export const DCJ_INBOX_MARK_CONVERSATION_READ_FAILURE = "DCJ_INBOX_MARK_CONVERSATION_READ_FAILURE";

export const MEMBERSHIP_GET_START = "MEMBERSHIP_GET_START";
export const MEMBERSHIP_GET_SUCCESS = "MEMBERSHIP_GET_SUCCESS";
export const MEMBERSHIP_GET_FAILURE = "MEMBERSHIP_GET_FAILURE";
export const MEMBERSHIP_TIMER_START = "MEMBERSHIP_TIMER_START";
export const MEMBERSHIP_RECOMPILE_START = "MEMBERSHIP_RECOMPILE_START";
export const MEMBERSHIP_RECOMPILE_FAILURE = "MEMBERSHIP_RECOMPILE_FAILURE";
export const MEMBERSHIP_CARE_COMPANION = "MEMBERSHIP_CARE_COMPANION";

export const PRICING_ESTIMATE_QUOTE = "PRICING_ESTIMATE_QUOTE";
export const PRICING_ESTIMATE_GET_PENDING = "PRICING_ESTIMATE_GET_PENDING";
export const PRICING_ESTIMATE_GET_SUCCESS = "PRICING_ESTIMATE_GET_SUCCESS";
export const DCJ_INBOX_SET_CONVERSATION_ID = "DCJ_INBOX_SET_CONVERSATION_ID";

export const DCJ_INBOX_MARK_CONVERSATION_FOR_FOLLOWUP = "DCJ_INBOX_MARK_CONVERSATION_FOR_FOLLOWUP";
export const DCJ_INBOX_MARK_CONVERSATION_FOR_FOLLOWUP_PENDING = "DCJ_INBOX_MARK_CONVERSATION_FOR_FOLLOWUP_PENDING";
export const DCJ_INBOX_MARK_CONVERSATION_FOR_FOLLOWUP_SUCCESS = "DCJ_INBOX_MARK_CONVERSATION_FOR_FOLLOWUP_SUCCESS";
export const DCJ_INBOX_MARK_CONVERSATION_FOR_FOLLOWUP_FAILURE = "DCJ_INBOX_MARK_CONVERSATION_FOR_FOLLOWUP_FAILURE";

export const GET_WELLBEING_REPORT = "GET_WELLBEING_REPORT";
export const GET_WELLBEING_REPORT_PENDING = "GET_WELLBEING_REPORT_PENDING";
export const GET_WELLBEING_REPORT_SUCCESS = "GET_WELLBEING_REPORT_SUCCESS";
export const GET_WELLBEING_REPORT_FAILURE = "GET_WELLBEING_REPORT_FAILURE";
export const GET_WELLNESS_REPORT_PDF = "GET_WELLNESS_REPORT_PDF";

export const DCJ_INBOX_GET_JOURNEY_CONVERSATION_ID = "DCJ_INBOX_GET_JOURNEY_CONVERSATION_ID";
export const DCJ_INBOX_GET_JOURNEY_CONVERSATION_ID_PENDING = "DCJ_INBOX_GET_JOURNEY_CONVERSATION_ID_PENDING";
export const DCJ_INBOX_GET_JOURNEY_CONVERSATION_ID_SUCCESS = "DCJ_INBOX_GET_JOURNEY_CONVERSATION_ID_SUCCESS";
export const DCJ_INBOX_GET_JOURNEY_CONVERSATION_ID_FAILURE = "DCJ_INBOX_GET_JOURNEY_CONVERSATION_ID_FAILURE";

export const GET_EPIC_ENCRYPT_CSN = "GET_EPIC_ENCRYPT_CSN";
export const GET_EPIC_ENCRYPT_CSN_PENDING = "GET_EPIC_ENCRYPT_CSN_PENDING";
export const GET_EPIC_ENCRYPT_CSN_SUCCESS = "GET_EPIC_ENCRYPT_CSN_SUCCESS";
export const GET_EPIC_ENCRYPT_CSN_FAILURE = "GET_EPIC_ENCRYPT_CSN_FAILURE";

export const GET_TERMS_FOR_VIDEO_VISIT_SHARELINK = "GET_TERMS_FOR_VIDEO_VISIT_SHARELINK";
export const GET_TERMS_FOR_VIDEO_VISIT_SHARELINK_PENDING = "GET_TERMS_FOR_VIDEO_VISIT_SHARELINK_PENDING";
export const GET_TERMS_FOR_VIDEO_VISIT_SHARELINK_SUCCESS = "GET_TERMS_FOR_VIDEO_VISIT_SHARELINK_SUCCESS";
export const GET_TERMS_FOR_VIDEO_VISIT_SHARELINK_FAILURE = "GET_TERMS_FOR_VIDEO_VISIT_SHARELINK_FAILURE";

export const GET_TERMS_STATUS_FOR_VIDEO_VISIT_SHARELINK = "GET_TERMS_STATUS_FOR_VIDEO_VISIT_SHARELINK";
export const GET_TERMS_STATUS_FOR_VIDEO_VISIT_SHARELINK_PENDING = "GET_TERMS_STATUS_FOR_VIDEO_VISIT_SHARELINK_PENDING";
export const GET_TERMS_STATUS_FOR_VIDEO_VISIT_SHARELINK_SUCCESS = "GET_TERMS_STATUS_FOR_VIDEO_VISIT_SHARELINK_SUCCESS";
export const GET_TERMS_STATUS_FOR_VIDEO_VISIT_SHARELINK_FAILURE = "GET_TERMS_STATUS_FOR_VIDEO_VISIT_SHARELINK_FAILURE";

export const ACCEPT_TERMS_FOR_VIDEO_VISIT_SHARELINK = "ACCEPT_TERMS_FOR_VIDEO_VISIT_SHARELINK";
export const ACCEPT_TERMS_FOR_VIDEO_VISIT_SHARELINK_PENDING = "ACCEPT_TERMS_FOR_VIDEO_VISIT_SHARELINK_PENDING";
export const ACCEPT_TERMS_FOR_VIDEO_VISIT_SHARELINK_SUCCESS = "ACCEPT_TERMS_FOR_VIDEO_VISIT_SHARELINK_SUCCESS";
export const ACCEPT_TERMS_FOR_VIDEO_VISIT_SHARELINK_FAILURE = "ACCEPT_TERMS_FOR_VIDEO_VISIT_SHARELINK_FAILURE";

export const HP_CONSENT_LIST = "HP_CONSENT_LIST";
export const REVOKE_HP_FHIR_GRANT = "REVOKE_HP_FHIR_GRANT";
export const REVOKE_HP_FHIR_GRANT_PENDING = "REVOKE_HP_FHIR_GRANT_PENDING";
export const REVOKE_HP_FHIR_GRANT_SUCCESS = "REVOKE_HP_FHIR_GRANT_SUCCESS";
export const REVOKE_HP_FHIR_GRANT_FAILURE = "REVOKE_HP_FHIR_GRANT_FAILURE";
export const SHOW_CARE_COACH_MODAL = "SHOW_CARE_COACH_MODAL";

export const MYCHART_DATA_TILE_TOUCHED = "MYCHART_DATA_TILE_TOUCHED";
export const MYCHART_DATA_TILE_TOUCHED_SUCCESS = "MYCHART_DATA_TILE_TOUCHED_SUCCESS";
export const MYCHART_DEMOGRAPHICS_COMPLETE = "MYCHART_DEMOGRAPHICS_COMPLETE";
export const MYCHART_DEMOGRAPHICS_COMPLETED = "MYCHART_DEMOGRAPHICS_COMPLETED";

export const SET_SELECTED_USERS = "SET_SELECTED_USERS";
export const CHECK_GET_INHOME_PREFILL = "CHECK_GET_PREFILL_DATA";
export const GET_INHOME_PREFILL = "GET_PREFILL_DATA";
export const GET_INHOME_PREFILL_RESULT = "GET_INHOME_PREFILL_RESULT";
export const SET_INHOME_LOCATION = "SET_INHOME_LOCATION";
export const GET_INHOME_VACCINES = "GET_INHOME_VACCINES";
export const SET_INHOME_VACCINES = "SET_INHOME_VACCINES";
export const GET_INHOME_VACCINES_RESULT = "GET_INHOME_VACCINES_RESULT";
export const GET_INHOME_ELIGIBILITY_Q = "GET_INHOME_ELIGIBILITY_Q";
export const GET_INHOME_ELIGIBILITY_Q_RESULT = "GET_INHOME_ELIGIBILITY_Q_RESULT";
export const GET_INHOME_ELIGIBILITY_COVID_Q = "GET_INHOME_ELIGIBILITY_COVID_Q";
export const GET_INHOME_ELIGIBILITY_COVID_Q_RESULT = "GET_INHOME_ELIGIBILITY_COVID_Q_RESULT";
export const REMOVE_VACCINE = "REMOVE_VACCINE";
export const SEND_INHOME_ELIGIBILITY_RESPONSES = "SEND_INHOME_ELIGIBILITY_RESPONSES";
export const GET_INHOME_APPTS = "GET_INHOME_APPTS";
export const GET_INHOME_APPTS_RESULT = "GET_INHOME_APPTS_RESULT"
export const SET_INHOME_DATETIME = "SET_INHOME_DATETIME";
export const BOOK_INHOME_APPT = "BOOK_INHOME_APPT";
export const BOOK_INHOME_APPT_RESULT = "BOOK_INHOME_APPT_RESULT";
export const CANCEL_INHOME_BOOKING = "CANCEL_INHOME_BOOKING";
export const SAVE_COVID_SERVICE_RESULTS = "SAVE_COVID_SERVICE_RESULTS";
export const RESET_COVID_DATA = "RESET_COVID_DATA";
export const VALIDATE_INHOME_ZIPCODE = "VALIDATE_INHOME_ZIPCODE";
export const SET_VALIDATE_INHOME_ZIPCODE_RESULT = "SET_VALIDATE_INHOME_ZIPCODE_RESULT";
export const INHOME_NUDGE_MODAL_VIEWED = "INHOME_NUDGE_MODAL_VIEWED";


export const SHOW_ONBOARDING_MODAL = "SHOW_ONBOARDING_MODAL";


export const MASTER_SPINNER_ON = "MASTER_SPINNER_ON";
export const MASTER_SPINNER_OFF = "MASTER_SPINNER_OFF";

export const UPDATE_THRIVE_TOOLTIP_PREFERENCE = "UPDATE_THRIVE_TOOLTIP_PREFERENCE";
export const SHOW_THRIVE_TOOLTIP = "SHOW_THRIVE_TOOLTIP";
export const HAS_SEEN_SCHEDULE_CARE_TOOLTIP = "HAS_SEEN_SCHEDULE_CARE_TOOLTIP ";
export const REQUEST_PROXY_SUGGESTION_LIST = "REQUEST_PROXY_SUGGESTION_LIST";
export const GET_PROXY_SUGGESTION_LIST = "GET_PROXY_SUGGESTION_LIST";
export const SET_PROXY_SELECTED_USERS = "SET_PROXY_SELECTED_USERS";
export const CLEAR_PROXY_SELECTED_USERS = "CLEAR_PROXY_SELECTED_USERS";
export const SET_SCREEN_BREAKPOINT = "SET_SCREEN_BREAKPOINT";
export const GET_PROXY_USER_PROXYFLOW_STATUS = "GET_PROXY_USER_PROXYFLOW_STATUS";

/**     MAMMOGRAPHY FLOW RELATED ACTIONS     **/
export const UPDATE_MAMMOGRAPHY_FLOW_SELECTED_OPTION = "UPDATE_MAMMOGRAPHY_FLOW_SELECTED_OPTION";
export const CLEAR_MAMMOGRAPHY_FLOW_SELECTED_OPTION = "CLEAR_MAMMOGRAPHY_FLOW_SELECTED_OPTION";
export const UPDATE_MAMMOGRAPHY_FLOW_FORM_INPUTS = "UPDATE_MAMMOGRAPHY_FLOW_FORM_INPUTS";
export const POST_MAMMOGRAPHY_FLOW_DATA = "POST_MAMMOGRAPHY_FLOW_DATA";
export const POST_MAMMOGRAPHY_FLOW_DATA_STATUS = "POST_MAMMOGRAPHY_FLOW_DATA_STATUS";
export const UPDATE_NO_MAMMOGRAPHY_FLOW_SELECTED_REASON = "UPDATE_NO_MAMMOGRAPHY_FLOW_SELECTED_REASON";
export const CLEAR_MAMMOGRAPHY_DATA_AFTER_SUBMIT = "CLEAR_MAMMOGRAPHY_DATA_AFTER_SUBMIT";
export const GET_MAMMOGRAPHY_FLOW_DATA = "GET_MAMMOGRAPHY_FLOW_DATA";
export const SAVE_CAREGAPS_SESSION_ID = "SAVE_CAREGAPS_SESSION_ID";
export const CLEAR_MAMMOGRAPHY_DATA_AFTER_ONCHANGE = "CLEAR_MAMMOGRAPHY_DATA_AFTER_ONCHANGE";

/**     CAREGAP FLOW RELATED ACTIONS     **/
export const UPDATE_CAREGAP_SELECTED_OPTION = "UPDATE_CAREGAP_SELECTED_OPTION";
export const UPDATE_NO_CAREGAP_FLOW_SELECTED_DATA = "UPDATE_NO_CAREGAP_FLOW_SELECTED_DATA";
export const GET_CAREGAP_FLOW_DATA = "GET_CAREGAP_FLOW_DATA";
export const UPDATE_CAREGAP_FLOW_FORM_INPUTS = "UPDATE_CAREGAP_FLOW_FORM_INPUTS";
export const POST_CAREGAP_FLOW_DATA_STATUS = "POST_CAREGAP_FLOW_DATA_STATUS";
export const CLEAR_CAREGAP_DATA_AFTER_SUBMIT = "CLEAR_CAREGAP_DATA_AFTER_SUBMIT";
export const POST_CAREGAP_FLOW_DATA = "POST_CAREGAP_FLOW_DATA";
export const POST_CAREGAP_SETUP_DATA = "POST_CAREGAP_SETUP_DATA";
export const CLEAR_CAREGAP_DATA_AFTER_ONCHANGE = "CLEAR_CAREGAP_DATA_AFTER_ONCHANGE";
export const GET_CAREGAP_FILE_ATTACHMENTS = "GET_CAREGAP_FILE_ATTACHMENTS";
export const GET_PATIENT_SCHEDULING_PERMISSIONS_START = 'GET_PATIENT_SCHEDULING_PERMISSIONS_START';
export const GET_PATIENT_SCHEDULING_PERMISSIONS_SUCCESS = 'GET_PATIENT_SCHEDULING_PERMISSIONS_SUCCESS';
export const GET_PATIENT_SCHEDULING_PERMISSIONS_FAILURE = 'GET_PATIENT_SCHEDULING_PERMISSIONS_FAILURE';

export const SHOW_ONBOARDING_PHASEONE_TOOLTIP = "SHOW_ONBOARDING_PHASEONE_TOOLTIP";
export const SHOW_ONBOARDING_PHASETWO_TOOLTIP = "SHOW_ONBOARDING_PHASETWO_TOOLTIP";
export const SHOW_ONBOARDING_PHASETHREE_TOOLTIP = "SHOW_ONBOARDING_PHASETHREE_TOOLTIP";
export const SHOW_ONBOARDING_PHASEFOUR_TOOLTIP = "SHOW_ONBOARDING_PHASEFOUR_TOOLTIP";
export const DISMISS_ONBOARDING_PHASEONE_TOOLTIP = "DISMISS_ONBOARDING_PHASEONE_TOOLTIP";
export const DISMISS_ONBOARDING_PHASETWO_TOOLTIP = "DISMISS_ONBOARDING_PHASETWO_TOOLTIP";
export const DISMISS_ONBOARDING_PHASETHREE_TOOLTIP = "DISMISS_ONBOARDING_PHASETHREE_TOOLTIP";
export const DISMISS_ONBOARDING_PHASEFOUR_TOOLTIP = "DISMISS_ONBOARDING_PHASEFOUR_TOOLTIP";
export const SHOW_LINK_MEDICALRECORD_PHASEONE_TOOLTIP = "SHOW_LINK_MEDICALRECORD_PHASEONE_TOOLTIP";
export const DISMISS_LINK_MEDICALRECORD_PHASEONE_TOOLTIP = "DISMISS_LINK_MEDICALRECORD_PHASEONE_TOOLTIP";

export const GET_PRIVACY_HEALTHPLAN_TEXT = "GET_PRIVACY_HEALTHPLAN_TEXT";
export const GET_PRIVACY_HEALTHPLAN_TEXT_SUCCESS = "GET_PRIVACY_HEALTHPLAN_TEXT_SUCCESS";
export const GET_PRIVACY_HEALTHPLAN_TEXT_FAILURE = "GET_PRIVACY_HEALTHPLAN_TEXT_FAILURE";

export const GET_PRIVACY_MYBSWH_TEXT = "GET_PRIVACY_MYBSWH_TEXT";
export const GET_PRIVACY_MYBSWH_TEXT_SUCCESS = "GET_PRIVACY_MYBSWH_TEXT_SUCCESS";
export const GET_PRIVACY_MYBSWH_TEXT_FAILURE = "GET_PRIVACY_MYBSWH_TEXT_FAILURE";

export const GET_PRIVACY_MYCHART_TEXT = "GET_PRIVACY_MYCHART_TEXT";
export const GET_PRIVACY_MYCHART_TEXT_SUCCESS = "GET_PRIVACY_MYCHART_TEXT_SUCCESS";
export const GET_PRIVACY_MYCHART_TEXT_FAILURE = "GET_PRIVACY_MYCHART_TEXT_FAILURE";

export const IS_PROXY_SWITCH_FOR_MYCHART_DEEPLINK = "IS_PROXY_SWITCH_FOR_MYCHART_DEEPLINK";

export const DISCOVER_TILE_DISMISS = "DISCOVER_TILE_DISMISS";
export const DISCOVER_TILE_DISMISS_SUCCESS = "DISCOVER_TILE_DISMISS_SUCCESS";
export const DISCOVER_TILE_DISMISS_FAILURE = "DISCOVER_TILE_DISMISS_FAILURE";
export const DISCOVER_TILE_UNDISMISS = "DISCOVER_TILE_UNDISMISS";

export const SET_SCRUBBING_IN_EMAIL_OPT_IN = "SET_SCRUBBING_IN_EMAIL_OPT_IN";
export const SET_SCRUBBING_IN_EMAIL_OPT_IN_SUCCESS = "SET_SCRUBBING_IN_EMAIL_OPT_IN_SUCCESS";
export const SET_SCRUBBING_IN_EMAIL_OPT_IN_FAILURE = "SET_SCRUBBING_IN_EMAIL_OPT_IN_FAILURE";

export const DASHBOARD_MENU_COLLAPSIBLE_STATE_CHANGE = "DASHBOARD_MENU_COLLAPSIBLE_STATE_CHANGE";

export const ACCEPT_BSW_DIGITAL_PRIVACY_POLICY = "GET_BSW_DIGITAL_PRIVACY_POLICY";
export const ACCEPT_BSW_DIGITAL_PRIVACY_POLICY_PENDING = "ACCEPT_BSW_DIGITAL_PRIVACY_POLICY_PENDING";
export const ACCEPT_BSW_DIGITAL_PRIVACY_POLICY_SUCCESS = "ACCEPT_BSW_DIGITAL_PRIVACY_POLICY_SUCCESS";
export const ACCEPT_BSW_DIGITAL_PRIVACY_POLICY_FAILURE = "ACCEPT_BSW_DIGITAL_PRIVACY_POLICY_FAILURE";
export const UPDATE_PRIVACY_MYBSWH_ACCEPTED = "UPDATE_PRIVACY_MYBSWH_ACCEPTED";

export const MYCHART_DATATILE_LANG_UPDATE = "MYCHART_DATATILE_LANG_UPDATE";


export const PROFILE_DATA_LOADED = "PROFILE_DATA_LOADED";